import React, { Component, Fragment , useContext, useState, useEffect, useRef } from "react";
import {
  Select,
  DatePicker,
  Form,
  Modal,
  Checkbox,
  InputNumber,
  Input,
  Table,
} from "antd";
import { Calendar, momentLocalizer } from "react-big-calendar";
import moment from "moment";
import "react-big-calendar/lib/css/react-big-calendar.css";
import CardCalendar from "./card_calendar_list";
import Cookies from "js-cookie";
import Api from "../../services/ServiceApi";
import ChangePath from "../../services/ServiceApi";
import { Translate } from "../../services";
import LoadingOverlay from 'react-loading-overlay';
// get_cdi_new_smart
const localizer = momentLocalizer(moment);
const dateFormatList = ["DD/MM/YYYY", "DD/MM/YY"];


//console.log(localizer,'localizer');
const { Option } = Select;
const { Search } = Input;
//import ChangePath from "../ServiceApi";

const EditableContext = React.createContext(null);
const EditableRow = ({ index, ...props }) => {
  const [form] = Form.useForm();
  return (
    <Form form={form} component={false}>
      <EditableContext.Provider value={form}>
        <tr {...props} />
      </EditableContext.Provider>
    </Form>
  );
};

const EditableCell = ({
  title,
  editable,
  children,
  dataIndex,
  record,
  handleSave,
  ...restProps
}) => {
  const [editing, setEditing] = useState(false);
  const inputRef = useRef(null);
  const form = useContext(EditableContext);
  useEffect(() => {
    if (editing) {
      inputRef.current.focus();
    }
  }, [editing]);

  const toggleEdit = () => {
    console.log('toggleEdit')
    setEditing(!editing);
    form.setFieldsValue({
      [dataIndex]: record[dataIndex],
    });
  };

  const save = async () => {
    console.log('save')
    try {
      const values = await form.validateFields();
      toggleEdit();
      handleSave({ ...record, ...values });
    } catch (errInfo) {
      console.log('Save failed:', errInfo);
    }
  };

  let childNode = children;

  if (editable) {
    childNode = editing ? (
      <Form.Item
        style={{
          margin: 0,
        }}
        name={dataIndex}
        rules={[
          {
            required: true,
            message: `${title} is required.`,
          },
        ]}
      >
        <Input ref={inputRef} onPressEnter={save} onBlur={save} />
      </Form.Item>
    ) : (
      <div
        className="editable-cell-value-wrap"
        style={{
          paddingRight: 24,
        }}
        onClick={toggleEdit}
      >
        {children}
      </div>
    );
  }

  return <td {...restProps}>{childNode}</td>;
};

// Check if object is empty
function isEmpty(obj) {
  for(var prop in obj) {
    if(obj.hasOwnProperty(prop)) {
      return false;
    }
  }

  return JSON.stringify(obj) === JSON.stringify({});
}

class CalendarPlan extends Component {
  formRef = React.createRef();
  constructor(props) {
    super(props);
    this.columns = [
      // {
      //   title: "Asset Id",
      //   dataIndex: "asset_id",
      //   key: "asset_id",
      // },
      // {
      //   title: "Asset Code1",
      //   dataIndex: "asset_code1",
      //   key: "asset_code1",
      // },
      {
        title: "Asset Code",
        dataIndex: "asset_code",
        key: "asset_code",
      },
      {
        title: "Asset Name",
        dataIndex: "asset_name",
        key: "asset_name",
        render: (item) => (
        <span>{item}</span>
        ),
      },
      {
        title: "Group Type",
        dataIndex: "group_type_name",
        key: "group_type_name",
      },
      {
        title: "Asset Type",
        dataIndex: "asset_type_name",
        key: "asset_type_name",
      },
      {
        title: "Order No",
        dataIndex: "order_no",
        key: "order_no",
        editable: true,
      },
    ];
    this.state = {
      events: [],
      //list: [1, 2, 3, 4, 5],
      list: [],
      set_asset: [],
      job_category: [],
      job_type: [],
      job_sub_type: [],
      planning_group: [],
      team: [],
      employee: [],
      ma_period: [],
      repeat: [],
      group_id: null,
      form: [],
      select_team: [],
      select_employee: [],
      // for sorting
      rowRecords: [],
      checkKeys: [],
      //
      startDate: new Date(),
      currentPage: 1,
      visible_success: false,
      visibleConf:false,
      select_team_emp: [
        { value: 1, text: "Team" },
        { value: 2, text: "Employee" },
      ],
      select_repeat_time: [
        { value: 1, text: "Doesn’t repeat" },
        { value: 2, text: "Every Weekday (Monday to Friday)" },
        { value: 3, text: "Every Weekend (Saturday to Sunday)" },
      ],
      select_repeat_day: [
        { value: 1, text: "Week" },
        { value: 2, text: "Month" },
        { value: 3, text: "Year" },
      ],
      select_asset_type: [
        { value: 1, text: "Week" },
        { value: 2, text: "Month" },
      ],
      fact_team: false,
      fact_emp: false,
      checked_auto: false,
      selected_emp: 0,
      asset_multi: "",
      //selectedRowKeys:["202007031716127025"],
      selectedRowKeys: [],
      columns_asset: [
        // {
        //   title: "Asset Id",
        //   dataIndex: "asset_id",
        //   key: "asset_id",
        // },
        {
          title: <Checkbox 
          onChange={() => this.CheckboxAsset("all")} 
          //checked={this.state.}
          //checked={() => {this.getCheckAll()}}
          ></Checkbox>,
          dataIndex: "",
          key: "",
          render: (item) => (
            <Checkbox
              onChange={() => this.CheckboxAsset(item)}
              checked={item["status_checkbox"]}
            ></Checkbox>
          ),

          // sorter: () => null,
        },
        {
          title: "Asset Code",
          dataIndex: "asset_code",
          key: "asset_code",
        },
        {
          title: "Asset Name",
          dataIndex: "asset_name",
          key: "asset_name",
          render: (item) => (
          <span>{item}</span>
          ),
        },
        {
          title: "Group Type",
          dataIndex: "group_type_name",
          key: "group_type_name",
        },
        {
          title: "Asset Type",
          dataIndex: "asset_type_name",
          key: "asset_type_name",
        },
      ],
      columns_select: [
        {
          title: "Asset Id",
          dataIndex: "asset_id",
          key: "asset_id",
        },
        {
          title: "Asset Code",
          dataIndex: "asset_code",
          key: "asset_code",
        },
        {
          title: "Asset Name",
          dataIndex: "asset_name",
          key: "asset_name",
          render: (item) => (
          <span>{item}</span>
          ),
        },
        {
          title: "Group Type",
          dataIndex: "group_type_name",
          key: "group_type_name",
        },
        {
          title: "Asset Type",
          dataIndex: "asset_type_name",
          key: "asset_type_name",
        },
        {
          title: "Order No",
          dataIndex: "order_no",
          key: "order_no",
          editable: true,
        },
      ],
      data_init: [],
      sel_emp_service_pm_id: 0,
      sel_multi_asset: [],
      sel_count_multi: 0,
      disabled_repeat: true,
      disabled_repeat_time: true,
      tab_auto:0,
      loading:true,
      dataSourceSel: [],
      tempCheckKeySel: [],
      tempSelected : true,
      arrConf: [],
      value_state:{},
      filter_search:'',
      arrReduceSel:[],
      filter_confirm:0,
      conf_first: 0,
      filter_act:0,
      arrFilterRep:[],
      tempMulti:[],
      tempRowKey:[],
      checkboxAll : false ,
      bk_set_asset:[],
      bk_data_asset:[],
      bk_tempMulti:[],
      tempFilter:[],
      group_list: [],
      // dataSourceSel: [
      //   {
      //     key: '0',
      //     name: 'Edward King 0',
      //     age: '32',
      //     address: 'London, Park Lane no. 0',
      //   },
      //   {
      //     key: '1',
      //     name: 'Edward King 1',
      //     age: '32',
      //     address: 'London, Park Lane no. 1',
      //   },
      // ],
    };
  }
  async componentDidMount() {

  //   Api.post("get_planning_group", {
  //     company_id: Cookies.get("companyid")
  //    ,operator_id: Cookies.get("operator_id")
  //    ,project_id: Cookies.get("project_id")
  //    ,is_active: 1
  //  }).then((val) =>{
  //      console.log(val);
  //      if(val.data.result.code.toLowerCase() === "p"){
  //          this.setState({
  //            planning_group: val.data.data.result
  //          })
  //      }
  //  })

  //   Api.post("ins_planning_group", {
    //   company_id: Cookies.get("companyid")
    // ,operator_id: Cookies.get("operator_id")
    // ,project_id: Cookies.get("project_id")
    // ,group_id:2
    // ,group_name:"Group 2"
    // ,is_active: 0
    // ,create_by": Cookies.get("usrId")
  //  }).then((val) =>{
  //      console.log(val);
  //  })

    const asseetcode = await Api.get(
      "get_cdi_new_smart",
      Cookies.get("companyid") + "/" + Cookies.get("operator_id") + "/"
    );
    //const asseetcode = await Api.get("get_cdi_new_smart", "1/" + 1 + "/")
    console.log("asseetcode", asseetcode);
    const get_job_category = await Api.post("get_job_category_V2", {
      company_id: Cookies.get("companyid"),
      operator_id: Cookies.get("operator_id"),
      project_id: Cookies.get("project_id"),
      job_category_id: null,
      is_active: 1,
      date_active: 1,
      // operator_id: Cookies.get("operator_id"),
    });

    const startOfMonth = moment().startOf("month").format("YYYY-MM-DD");
    const endOfMonth = moment().endOf("month").format("YYYY-MM-DD");
    const job_calendar = await Api.post("v2/jobEmployeeCalender", {
      company_id: Cookies.get("companyid"),
      operator_id: Cookies.get("operator_id"),
      project_id: Cookies.get("project_id"),
      work_pm_start: startOfMonth,
      work_pm_end: endOfMonth,
      group_id: null ,
      group_name: null,
    });

    const job_calendar1 = await Api.post("v2/jobEmployeeCalender", {
      company_id: Cookies.get("companyid"),
      operator_id: Cookies.get("operator_id"),
      project_id: Cookies.get("project_id"),
      auto_gen_job: 1,
      work_pm_start: startOfMonth,
      work_pm_end: endOfMonth,
      group_id: null ,
      group_name: null,
    });
    
    const plan_group_list = await Api.post("oper_get_query_group_list", {
      company_id: Cookies.get("companyid"),
      operator_id: Cookies.get("operator_id"),
      project_id: Cookies.get("project_id"),
      query_id: "1",
      query_module: "PLAN",
      param_text: "@company_id:$" + Cookies.get("companyid") +"##@operator_id:$" + Cookies.get("operator_id") + "##@project_id:$"+ Cookies.get("project_id"),
      where_cond: ""
      //sql_where: null,
    });

    let init = {
      repeat_time : 1,
      repeat_day: 1,
      start_date: moment(this.state.startDate, dateFormatList[0]),
      end_date: moment(this.state.startDate, dateFormatList[0])
    };
    if (this.formRef.current !== null) {
      this.formRef.current.setFieldsValue(init);
    }
    this.setState({
      startOfMonth : startOfMonth,
      endOfMonth : endOfMonth,
      data_init: init,
    })

    
    for (let i = 0; i < job_calendar.data.data.length; i++) {
      let title = "";
      let s_date = job_calendar.data.data[i].emp_work_pm_start;
      let e_date = job_calendar.data.data[i].emp_work_pm_end;

      let repeat_time = job_calendar.data.data[i].repeat_time;
      // let repeat_every = job_calendar.data.data[i].repeat_every;
      // let repeat_day = job_calendar.data.data[i].repeat_day;

      //console.log('job_calendar',job_calendar.data.data[i]);
      if (
        job_calendar.data.data[i].emp_id === null &&
        job_calendar.data.data[i].team_id === 0
      ) {
        //console.log(i+' asset_code : '+job_calendar.data.data[i].asset_code);
        if (
          job_calendar.data.data[i].asset_code !== "" &&
          job_calendar.data.data[i].asset_code !== null
        ) {
          //title = job_calendar.data.data[i].asset_code
          title = job_calendar.data.data[i].plan_name;
        } else {
          //title = "Asset List (ID:"+job_calendar.data.data[i].emp_service_pm_id+")"
          title = job_calendar.data.data[i].plan_name;
        }
      } else if (
        job_calendar.data.data[i].emp_id !== null &&
        job_calendar.data.data[i].team_id === 0
      ) {
        // console.log(i+' emp');
        title = job_calendar.data.data[i].emp_name;
      } else if (
        job_calendar.data.data[i].emp_id === null &&
        job_calendar.data.data[i].team_id !== 0
      ) {
        // console.log(i+' team');
        title = job_calendar.data.data[i].team_name;
      } else if (
        job_calendar.data.data[i].emp_id !== null &&
        job_calendar.data.data[i].team_id !== 0
      ) {
        // console.log(i+' emp2');
        title = job_calendar.data.data[i].emp_name;
      }

      // console.log(repeat_time,'repeat_time');
      if (repeat_time === 1) {
        console.log("mon-fri");
        /** display mon-fri only */
        let start_calendar = "",
          end_calendar = "";
        for (let j = 0; ; j++) {
          // console.log('j : '+j);

          // console.log('loop s_date repeat_time1',s_date);
          let check_date = moment(s_date).add(j, "days").format("YYYY-MM-DD");
          //console.log('day : '+check_date.day());
          // console.log('loop check_date repeat_time1',check_date);
          let newDate = new Date(check_date);
          // console.log('loop newDate repeat_time1',newDate);

          if (
            start_calendar === "" &&
            newDate.getDay() !== 0 &&
            newDate.getDay() !== 6
          ) {
            start_calendar = newDate;
            end_calendar = newDate;
          }
          // console.log('start_calendar : '+start_calendar);
          // console.log('end_calendar : '+end_calendar);
          // console.log('newDate : '+newDate.getDay());
          if (
            start_calendar !== "" &&
            newDate.getDay() !== 0 &&
            newDate.getDay() !== 6
          ) {
            end_calendar = newDate;
          } else {
            // console.log('else start_calendar  : '+start_calendar);
            // console.log('else end_calendar : '+end_calendar);
            this.state.events.push({
              start: start_calendar,
              end: end_calendar,
              title: title,
              item: job_calendar.data.data[i],
            });

            start_calendar = "";
            end_calendar = "";
          }
          //console.log('check_date : '+check_date);

          if (moment(check_date).isSame(moment(e_date).format("YYYY-MM-DD"))) {
            if (newDate.getDay() !== 0 && newDate.getDay() !== 6) {
              this.state.events.push({
                start: start_calendar,
                end: end_calendar,
                title: title,
                item: job_calendar.data.data[i],
              });
            }
            break;
          }
        } //end for
      } else if (repeat_time === 2) {
        console.log("sat-sun");
        /** display sat , sun only */
        let start_calendar = "",
          end_calendar = "";
        for (let j = 0; ; j++) {
          // console.log('loop s_date repeat_time2',s_date);
          let check_date = moment(s_date).add(j, "days").format("YYYY-MM-DD");
          // console.log('loop check_date repeat_time2',check_date);
          let newDate = new Date(check_date);
          // console.log('loop newDate repeat_time2',newDate);
          if (
            start_calendar === "" &&
            newDate.getDay() !== 1 &&
            newDate.getDay() !== 2 &&
            newDate.getDay() !== 3 &&
            newDate.getDay() !== 4 &&
            newDate.getDay() !== 5
          ) {
            start_calendar = newDate;
            end_calendar = newDate;
          }

          if (
            start_calendar !== "" &&
            newDate.getDay() !== 1 &&
            newDate.getDay() !== 2 &&
            newDate.getDay() !== 3 &&
            newDate.getDay() !== 4 &&
            newDate.getDay() !== 5
          ) {
            end_calendar = newDate;
          } else {
            // console.log('else start_calendar  : '+start_calendar);
            // console.log('else end_calendar : '+end_calendar);
            this.state.events.push({
              start: start_calendar,
              end: end_calendar,
              title: title,
              item: job_calendar.data.data[i],
            });

            start_calendar = "";
            end_calendar = "";
          }

          if (moment(check_date).isSame(moment(e_date).format("YYYY-MM-DD"))) {
            if (
              newDate.getDay() !== 1 &&
              newDate.getDay() !== 2 &&
              newDate.getDay() !== 3 &&
              newDate.getDay() !== 4 &&
              newDate.getDay() !== 5
            ) {
              this.state.events.push({
                start: start_calendar,
                end: end_calendar,
                title: title,
                item: job_calendar.data.data[i],
              });
            }
            break;
          }
        } //end for
      } else {
        /** repeat_time === 0 */
        //console.log('donot repeat');
        //let check_date =  moment(s_date).format("YYYY-MM-DD");
        /*let check_y_date =  moment(s_date).format("YYYY");
      let check_m_date =  moment(s_date).format("MM");
      let check_d_date =  moment(s_date).format("DD");
      console.log('check_y_date',check_y_date);
      console.log('check_m_date',check_m_date);
      console.log('check_d_date',check_d_date);
      let newDate = new Date(check_y_date, check_m_date, check_d_date)
      console.log('newDate',newDate);

      let end_y_date =  moment(e_date).format("YYYY");
      let end_m_date =  moment(e_date).format("MM");
      let end_d_date =  moment(e_date).format("DD");
      let newEndDate = new Date(end_y_date, end_m_date, end_d_date)
      console.log('newEndDate',newEndDate);*/

        let check_date = moment(s_date).format("YYYY-MM-DD");
        let newDate = new Date(check_date);

        let end_date = moment(e_date).format("YYYY-MM-DD");
        let newEndDate = new Date(end_date);

        // let check_end_date =  moment(e_date).add(1, 'days').format("YYYY-MM-DD");
        // console.log('check_end_date',check_end_date);
        //let check_end_date =  moment(e_date).format("YYYY-MM-DD");

        console.log("newDate", newDate);
        console.log("newEndDate", newEndDate);
        this.state.events.push({
          start: newDate,
          end: newEndDate,
          title: title,
          item: job_calendar.data.data[i],
        });
      }
    }

   

    //console.log(calendar_list.data.data,'data calendar_list');
    for (let i = 0; i < asseetcode.data.data.length; i++) {
      asseetcode.data.data[i]["status_checkbox"] = false;
      asseetcode.data.data[i]["id"] = i;
    }

    if(!isEmpty(plan_group_list.data.data)){
      this.setState({
              group_list: plan_group_list.data.data.list_planning_group,
      })
    } else {
      this.setState({
        group_list: [],
      })
    }

    this.setState({
      job_category: get_job_category.data.data.result_data,
      // group_list: plan_group_list.data.data.list_planning_group,
      //select_team: get_team.data.data.result_list_ma_team,
      //select_employee: get_emp.data.data.result_list_ma_employee,
      list: job_calendar1.data.data,
      //list: job_calendar.data.data,
      set_asset: asseetcode.data.data.data,
      data_asset: asseetcode.data.data.data,
      loading:false
    });


    //console.log(this.state.events,'events');
  }

  async changeCalendar(date) {
    this.setState({
      events: [],
    });
    console.log("changeCalendar date", date);
    const startOfMonth = moment(date).startOf("month").format("YYYY-MM-DD");
    const endOfMonth = moment(date).endOf("month").format("YYYY-MM-DD");
    console.log("startOfMonth", startOfMonth);
    console.log("endOfMonth", endOfMonth);
    console.log("endOfMonth", endOfMonth);
    const job_calendar = await Api.post("v2/jobEmployeeCalender", {
      company_id: Cookies.get("companyid"),
      operator_id: Cookies.get("operator_id"),
      project_id: Cookies.get("project_id"),      
      work_pm_start: startOfMonth,
      work_pm_end: endOfMonth,
      group_id: null ,
      group_name: null,
    });
    console.log(job_calendar, "job_calendar");

    const job_calendar1 = await Api.post("v2/jobEmployeeCalender", {
      company_id: Cookies.get("companyid"),
      operator_id: Cookies.get("operator_id"),
      project_id: Cookies.get("project_id"),
      auto_gen_job:  (this.state.tab_auto === 0 ? 1:0),
      work_pm_start: startOfMonth,
      work_pm_end: endOfMonth,
      group_id: null ,
      group_name: null,
    });

    //console.log(get_emp_service_pm,'get_emp_service_pm');
    for (let i = 0; i < job_calendar.data.data.length; i++) {
      let title = "";
      let s_date = job_calendar.data.data[i].emp_work_pm_start;
      let e_date = job_calendar.data.data[i].emp_work_pm_end;

      let repeat_time = job_calendar.data.data[i].repeat_time;
      // let repeat_every = job_calendar.data.data[i].repeat_every;
      // let repeat_day = job_calendar.data.data[i].repeat_day;

      //console.log('job_calendar',job_calendar.data.data[i]);
      if (
        job_calendar.data.data[i].emp_id === null &&
        job_calendar.data.data[i].team_id === 0
      ) {
        //console.log(i+' asset_code : '+job_calendar.data.data[i].asset_code);
        if (
          job_calendar.data.data[i].asset_code !== "" &&
          job_calendar.data.data[i].asset_code !== null
        ) {
          //title = job_calendar.data.data[i].asset_code
          title = job_calendar.data.data[i].plan_name;
        } else {
          //title = "Asset List (ID:"+job_calendar.data.data[i].emp_service_pm_id+")"
          title = job_calendar.data.data[i].plan_name;
        }
      } else if (
        job_calendar.data.data[i].emp_id !== null &&
        job_calendar.data.data[i].team_id === 0
      ) {
        // console.log(i+' emp');
        title = job_calendar.data.data[i].emp_name;
      } else if (
        job_calendar.data.data[i].emp_id === null &&
        job_calendar.data.data[i].team_id !== 0
      ) {
        // console.log(i+' team');
        title = job_calendar.data.data[i].team_name;
      } else if (
        job_calendar.data.data[i].emp_id !== null &&
        job_calendar.data.data[i].team_id !== 0
      ) {
        // console.log(i+' emp2');
        title = job_calendar.data.data[i].emp_name;
      }

      if (repeat_time === 1) {
        /** display mon-fri only */
        let start_calendar = "",
          end_calendar = "";
        for (let j = 0; ; j++) {
          // console.log('j : '+j);

          let check_date = moment(s_date).add(j, "days").format("YYYY-MM-DD");
          //console.log('day : '+check_date.day());
          let newDate = new Date(check_date);

          if (
            start_calendar === "" &&
            newDate.getDay() !== 0 &&
            newDate.getDay() !== 6
          ) {
            start_calendar = newDate;
            end_calendar = newDate;
          }
          // console.log('start_calendar : '+start_calendar);
          // console.log('end_calendar : '+end_calendar);
          // console.log('newDate : '+newDate.getDay());
          if (
            start_calendar !== "" &&
            newDate.getDay() !== 0 &&
            newDate.getDay() !== 6
          ) {
            end_calendar = newDate;
          } else {
            // console.log('else start_calendar  : '+start_calendar);
            // console.log('else end_calendar : '+end_calendar);
            this.state.events.push({
              start: start_calendar,
              end: end_calendar,
              title: title,
              item: job_calendar.data.data[i],
            });

            start_calendar = "";
            end_calendar = "";
          }
          //console.log('check_date : '+check_date);

          if (moment(check_date).isSame(moment(e_date).format("YYYY-MM-DD"))) {
            if (newDate.getDay() !== 0 && newDate.getDay() !== 6) {
              this.state.events.push({
                start: start_calendar,
                end: end_calendar,
                title: title,
                item: job_calendar.data.data[i],
              });
            }
            break;
          }
        } //end for
      } else if (repeat_time === 2) {
        /** display sat , sun only */
        let start_calendar = "",
          end_calendar = "";
        for (let j = 0; ; j++) {
          let check_date = moment(s_date).add(j, "days").format("YYYY-MM-DD");
          let newDate = new Date(check_date);
          if (
            start_calendar === "" &&
            newDate.getDay() !== 1 &&
            newDate.getDay() !== 2 &&
            newDate.getDay() !== 3 &&
            newDate.getDay() !== 4 &&
            newDate.getDay() !== 5
          ) {
            start_calendar = newDate;
            end_calendar = newDate;
          }

          if (
            start_calendar !== "" &&
            newDate.getDay() !== 1 &&
            newDate.getDay() !== 2 &&
            newDate.getDay() !== 3 &&
            newDate.getDay() !== 4 &&
            newDate.getDay() !== 5
          ) {
            end_calendar = newDate;
          } else {
            // console.log('else start_calendar  : '+start_calendar);
            // console.log('else end_calendar : '+end_calendar);
            this.state.events.push({
              start: start_calendar,
              end: end_calendar,
              title: title,
              item: job_calendar.data.data[i],
            });

            start_calendar = "";
            end_calendar = "";
          }

          if (moment(check_date).isSame(moment(e_date).format("YYYY-MM-DD"))) {
            if (
              newDate.getDay() !== 1 &&
              newDate.getDay() !== 2 &&
              newDate.getDay() !== 3 &&
              newDate.getDay() !== 4 &&
              newDate.getDay() !== 5
            ) {
              this.state.events.push({
                start: start_calendar,
                end: end_calendar,
                title: title,
                item: job_calendar.data.data[i],
              });
            }
            break;
          }
        } //end for
      } else {
        /** repeat_time === 0 */
        /*let check_y_date =  moment(s_date).format("YYYY");
      let check_m_date =  moment(s_date).format("MM");
      let check_d_date =  moment(s_date).format("DD");
      console.log('check_y_date',check_y_date);
      console.log('check_m_date',check_m_date);
      console.log('check_d_date',check_d_date);
      let newDate = new Date(check_y_date, check_m_date, check_d_date)
      console.log('newDate',newDate);

      let end_y_date =  moment(e_date).format("YYYY");
      let end_m_date =  moment(e_date).format("MM");
      let end_d_date =  moment(e_date).format("DD");
      let newEndDate = new Date(end_y_date, end_m_date, end_d_date)
      console.log('newEndDate',newEndDate);*/

        let check_date = moment(s_date).format("YYYY-MM-DD");
        let newDate = new Date(check_date);

        let end_date = moment(e_date).format("YYYY-MM-DD");
        let newEndDate = new Date(end_date);

        this.state.events.push({
          start: newDate,
          end: newEndDate,
          title: title,
          item: job_calendar.data.data[i],
        });
      }
    } //end for

    this.setState({
      startOfMonth : startOfMonth,
      endOfMonth: endOfMonth,
      list: job_calendar1.data.data,
    });
  }

  async onModal(name, mode, visible) {
    // console.log(this.formRef.current, "onModal current");
    // console.log(this.state.data_asset);
    // console.log("visible", visible);
    // console.log('onModal checkboxAll',this.state.checkboxAll);
    this.setState({
      // checkboxAll:false,
      tempMulti:[]
    })

    if (visible === false && this.formRef.current !== null) {
      console.log("resetFields");
      this.formRef.current.resetFields();
      console.log(this.formRef.current, "onModal reset current");
      // reset those sorting value
      this.setState({ checkKeys: [], rowRecords: [] });
    }
    let dateNow = new Date();
    let var_time = 0,
      var_every = 0,
      var_day = 0;
    let init = [];
    if (this.formRef.current !== null) {
      console.log("current not null");
      if(this.state.checked_auto){        
        var_time = "";
        var_every = 1;
        var_day = "";
      }else{
        var_time = 1;
        var_every = 1;
        var_day = 1;
      }
      init = {
        job_category: "",
        job_type_id: "",
        job_sub_type_id: "",
        planning_group: null,
        repeat_time: var_time,
        repeat_every: var_every,
        repeat_day: var_day,
        
        //search_asset: "",
        plan_name: ""
      };
      this.formRef.current.setFieldsValue(init);
    } else {
      // if(this.formRef.current !== null){
      console.log("onModal current null!!!");
      if(this.state.checked_auto){        
        var_time = "";
        var_every = 1;
        var_day = "";
      }else{
        var_time = 1;
        var_every = 1;
        var_day = 1;
      }
      init = {
        job_category: "",
        job_type_id: "",
        job_sub_type_id: "",
        repeat_time: var_time,
        planning_group: null,
        repeat_every: var_every,
        repeat_day: var_day,
        //search_asset: "",
        plan_name: ""
      };
    }

    console.log("onModal set data_init ", init);
    // console.log('after');
    // console.log('mode',mode);
    // console.log('data_init',init);
    // console.log('startDate',dateNow);
    // console.log('visible',visible);
    // visible = true

    // const asseetcode = await Api.get(
    //   "get_cdi_new_smart",
    //   Cookies.get("companyid") + "/" + Cookies.get("operator_id") + "/"
    // );
    if(mode === "add"){
      this.setState({
        //dataSourceSel:[]
      });
    }

    if (name === "main") {
      this.setState({
        mode,
        data_init: init,
        startDate: dateNow,
        selectedRowKeys: [],
        visible: visible,
        //disabled_repeat: false,
        currentPage: 1,
        checked_auto:false,
        data_asset: this.state.data_asset,
        checkboxAll:false,
        filter_search:''
      });
    } else {
      this.setState({
        mode,
        data_init: init,
        startDate: dateNow,
        selectedRowKeys: [],
        visible_sub: visible,
        currentPage: 1,
        job_type: [],
        job_sub_type: [],
        planning_group:[],
        checked_auto:false,
        data_asset:this.state.data_asset,
        //disabled_repeat: false,
        checkboxAll:true,
        filter_search:''
      });
    }
  }

  handleSave = (row) => {
    console.log('handleSave row : ',row);
    const newData = [...this.state.dataSourceSel];
    console.log('handleSave init newData : ',newData);
    const index = newData.findIndex((item) => row.asset_code === item.asset_code);
    // const index = newData.findIndex((item) => row.key === item.key);
    const item = newData[index];
    newData.splice(index, 1, { ...item, ...row });
    console.log('handleSave after newData : ',newData);
    this.setState({
      dataSourceSel: newData,
    });
  };

  GetSortOrder = (prop) => {    
    return function(a, b) {    
        if (a[prop] > b[prop]) {    
            return 1;    
        } else if (a[prop] < b[prop]) {    
            return -1;    
        }    
        return 0;    
    }    
  }

  getCheckAll = () => {
    console.log('checkboxAll',this.state.checkboxAll);
    return false
  }

  //CheckboxAsset = (value , check_title) => {
  CheckboxAsset = (value ) => {
    console.log('CheckboxAsset : ',value);
    console.log('this.state.checkboxAll : ',this.state.checkboxAll);
    console.log('this.state.tempMulti : ',this.state.tempMulti);
    // console.log('currentPage : ',this.state.currentPage);
    console.log('filter_search : ',this.state.filter_search);
    // console.log('check_title : ',this.state.tempMulti);
    // let search_found = 0;
    
    if (value === "all") {
      /** click multi select */
      var newArrMulti = []
      if(this.state.filter_search === ''){
        /** no filter  */
        if(this.state.checkboxAll === false){
          // if(check_title === false){
          /** select all */
          console.log('select all')
          // if(){

          // }else{

          // }
          
          for (let i = 0; i < this.state.data_asset.length; i++) {
            this.state.data_asset[i]["status_checkbox"] = true
            newArrMulti.push(this.state.data_asset[i]["asset_id"])
          }
          
          this.setState({
            data_asset: this.state.data_asset,
            set_asset: this.state.data_asset,
            checkboxAll : true,
            tempMulti : newArrMulti,
          });
        }
        else{
          /** remove select all */
          console.log('remove select all')
          for (let i = 0; i < this.state.data_asset.length; i++) {
            this.state.data_asset[i]["status_checkbox"] = false
          }
          newArrMulti = []
          this.setState({
            data_asset: this.state.data_asset,
            set_asset: this.state.data_asset,
            checkboxAll : false ,
            tempMulti : newArrMulti,
          });
        }
      }else{
        /** filter and click multi */

      //   var newArrMulti = []
      //   /** begin check status */
      //   if(this.state.checkboxAll === false){
      //     /** search status false */
          
      //     for (let i = 0; i < this.state.data_asset.length; i++) {
      //       if(this.state.data_asset[i]["status_checkbox"] === false){
      //         search_found = 1
      //         this.state.data_asset[i]["status_checkbox"] = true
      //         newArrMulti.push(this.state.data_asset[i]["asset_id"])
      //       }//end if            
      //     }//end for          
      //     //newArrMulti = this.state.data_asset;
      //     this.setState({
      //       data_asset: this.state.data_asset,
      //       checkboxAll : true,
      //       tempMulti : newArrMulti,
      //     });

      //   }else{
      //     /** search status true */
      //     for (let i = 0; i < this.state.data_asset.length; i++) {
      //       if(this.state.data_asset[i]["status_checkbox"] === true){
      //         search_found = 1
      //         this.state.data_asset[i]["status_checkbox"] = false
      //         // newArrMulti.push(this.state.data_asset[i]["asset_id"])
      //       }//end if            

      //     }//end for  
      //     newArrMulti = []
      //     this.setState({
      //       data_asset: this.state.data_asset,
      //       checkboxAll : false ,
      //       tempMulti : newArrMulti,
      //     });

      //   }
      //   /** end check status */

      // console.log('search_found : ',search_found);
      // if(search_found === 0){
        
        // var newArrFilter = []
        console.log('filter data_asset',this.state.data_asset);
        console.log('filter set_asset',this.state.set_asset);

        var newArrFilter = this.state.tempMulti     
        var found = [];
        console.log('before filter all newArrFilter',newArrFilter);
        if(this.state.checkboxAll === false){
          // if(check_title === false){
          
          /** filter all */
          for (let i = 0; i < this.state.data_asset.length; i++) {
           found = newArrFilter.includes(this.state.data_asset[i]["asset_id"]);
            if(!found){
              this.state.data_asset[i]["status_checkbox"] = true
              newArrFilter.push(this.state.data_asset[i]["asset_id"])
            }//end if         
          }//end for

         /* for (let i = 0; i < this.state.set_asset.length; i++) {
            this.state.set_asset[i]["status_checkbox"] = true
            newArrFilter.push(this.state.set_asset[i]["asset_id"])
          }*/

          console.log('after filter all newArrFilter',newArrFilter);

          this.setState({
            data_asset: this.state.data_asset,
            checkboxAll : true,
            tempMulti : newArrFilter,
          });

        }else{
          /** remove filter all */
          let temp_data = this.state.data_asset
          for (let i = 0; i < temp_data.length; i++) {
            //var found = this.state.tempMulti.includes(value["asset_id"]);
            found = newArrFilter.includes(temp_data[i]["asset_id"]);
            console.log('found',found);
            if(found){
              let arr = []
              temp_data[i]["status_checkbox"] = false
              arr = newArrFilter.filter(function(itm){
                return itm !== temp_data[i]["asset_id"];
              });

              //console.log('arr : ',arr);
              // newArrFilter = this.state.tempMulti.filter(function(itm){
              //   return itm !== value["asset_id"];
              // });
              newArrFilter = arr
              //console.log('found remove newArrFilter',newArrFilter);
            }
          } //end for

          /*for (let i = 0; i < this.state.set_asset.length; i++) {
            this.state.set_asset[i]["status_checkbox"] = false
          }
          newArrFilter = []*/


          console.log('after remove filter all newArrFilter',newArrFilter);

          this.setState({
            data_asset: temp_data,
            checkboxAll : false,
            tempMulti : newArrFilter,
          });

        }

      // }

        // var difference = tempRowRecords.filter(x => this.state.tempMulti.indexOf(x) === -1);
        // console.log('difference : ',difference);
        // var found = this.state.tempMulti.includes(value["asset_id"]);
        // console.log('filter found',found);

      }
     
    }
    else {
      /** begin click 1 item */
      console.log('click 1 item >> filter_search',this.state.filter_search);
      value["status_checkbox"] = !value["status_checkbox"];
      if(this.state.filter_search === ''){
        /** no filter */
        found = this.state.tempMulti.includes(value["asset_id"]);
        console.log('found :',found);
        var newArrMulti = this.state.tempMulti

        if(found){
          /** remove */
          newArrMulti = this.state.tempMulti.filter(function(itm){
            return itm !== value["asset_id"];
          });
        }else{
          /** add */
          newArrMulti.push(value["asset_id"])
        }
        console.log('newArrMulti',newArrMulti);
        // console.log('data_asset : ',this.state.data_asset);  
        
        this.setState({
          tempMulti:newArrMulti,
          data_asset: this.state.data_asset,
          set_asset: this.state.data_asset,
        });

      }else{
        /** filter */
        // console.log('filter data_asset',this.state.data_asset);
        // console.log('filter set_asset',this.state.set_asset);

        var newArrFilter = this.state.tempMulti
        found = this.state.tempMulti.includes(value["asset_id"]);
        console.log('filter found',found);
        if(found){
          /** remove filter */
          newArrFilter = this.state.tempMulti.filter(function(itm){
            return itm !== value["asset_id"];
          });

        }else{
          /** add filter */
          newArrFilter.push(value["asset_id"])
        }

        console.log('newArrFilter',newArrFilter);
        // console.log('data_asset : ',this.state.data_asset);  

        this.setState({
          tempMulti:newArrFilter,
          data_asset: this.state.data_asset,
        });

      }
      /** end click 1 item */
    }
  };

  handleConf = async (values) => {
    const {
      setDataAssign,
      dataSourceSel,
      rowRecords,
      arrConf,
      tempMulti
    } = this.state;

    console.log('arrConf', arrConf);
    console.log('rowRecords', rowRecords);
    console.log('rowRecords len', rowRecords.length);
    console.log('setDataAssign', setDataAssign);
    console.log(values, "handleConf values");
    console.log('dataSourceSel', dataSourceSel);

    let my_val = values
    let arrSel = []
    // let arrSel2 = []
    let filteredData = []
    // let filteredData2 = []
    // let tempArray = []

    tempMulti.map((item) => {
    const tempData = JSON.parse(JSON.stringify(this.state.set_asset));
    filteredData = tempData.filter((o) =>
      Object.keys(o).some((k) => {
        return String(o[k]).toLowerCase().includes(item.toLowerCase());
      })
    );

    console.log(tempData)
  
    arrSel.push(filteredData[0])
      //i++;
    });

    let i2 = 1;
    arrSel.forEach(function (element) {       
              element.order_no = i2;
              i2++;
            });
            
    console.log(arrSel);

    var temp_value = this.formRef.current.getFieldsValue(true);

    var new_my_val = my_val;
    new_my_val["group_id"] = temp_value.group_id;
    new_my_val["group_name"] = temp_value.group_name;
            
    // console.log(this.formRef.current.getFieldsValue(true));

            this.setState({
              dataSourceSel:arrSel,
              visible:false,
              visibleConf:true,
              value_state:new_my_val,
            })
        
    // if(filter_search === '' && filter_confirm !== 1 && filter_act !== 1){
    //   console.log('no filter before ',rowRecords);
    //   let i = 1;
    //   arrSel.forEach(function (element) {       
    //     element.order_no = i;
    //     i++;
    //   });

    //   console.log('after arrSel', arrSel);

    //   /** begin confirm asset */
    //   const tempRowRecords = JSON.parse(
    //     JSON.stringify(this.state.selectedRowKeys)
    //   );
    //   this.setState(
    //     {
    //       rowRecords: [...this.state.rowRecords, ...tempRowRecords],
    //       selectedRowKeys: [
    //         ...new Set([...this.state.rowRecords, ...tempRowRecords]),
    //       ],
    //     },
    //     () => {
          
    //       console.log("handleConf after add row keys", this.state.selectedRowKeys);

    //       this.state.selectedRowKeys.map((item) => {
    //         const tempData = JSON.parse(JSON.stringify(this.state.set_asset));
    //         filteredData2 = tempData.filter((o) =>
    //           Object.keys(o).some((k) => {
    //             return String(o[k]).toLowerCase().includes(item.toLowerCase());
    //           })
    //         );
          
    //         arrSel2.push(filteredData2[0])
    //           //i++;
    //         });

    //         console.log('handleConf arrSel2 : ',arrSel2)

    //         let i2 = 1;
    //         arrSel2.forEach(function (element) {       
    //           element.order_no = i2;
    //           i2++;
    //         });
    //     }
        
    //   );
    //   /** end confirm asset */

    //   //console.log('handleConf filter_search : ',filter_search)
    //   //if(filter_search === ''){
    //     /** No Filter */
    //     console.log('no filter')
    //     let c_dtSource = dataSourceSel.length
    //     let c_arrSel2 = arrSel2.length
    //     let new_arrSel = []   
           
    //     let i3 = 1;
    //     console.log('arrReduceSel',arrReduceSel)
    //     console.log('this.state.selectedRowKeys : ',this.state.selectedRowKeys);
    //     console.log('c_dtSource',c_dtSource)
    //     console.log('c_arrSel2',c_arrSel2)
    //     console.log('c_selectedRowKeys',this.state.selectedRowKeys.length)

        

    //     // if(c_dtSource === c_arrSel2 && c_arrSel2 === this.state.selectedRowKeys.length){
    //     //   new_arrSel = arrSel2
    //     // }else if(c_dtSource < c_arrSel2 && c_arrSel2 === this.state.selectedRowKeys.length){
    //     //   new_arrSel = arrSel2
    //     // }else if(c_dtSource < c_arrSel2 ){
    //     //   // decrease nofilter
    //     //   new_arrSel = dataSourceSel
    //     //   new_arrSel.forEach(function (element) {       
    //     //     element.order_no = i3;
    //     //     i3++;
    //     //   });
    //     //   arrSel2 = []
    //     //   arrSel2 = new_arrSel
    //     // }
    //     if(arrReduceSel.length !== 0){
    //       let i4 = 1;
    //       // new_arrSel = [] 
    //       new_arrSel = arrReduceSel
    //       new_arrSel.forEach(function (element) {       
    //         element.order_no = i4;
    //         i4++;
    //       });
    //       arrSel2 = new_arrSel
    //     }

    //     console.log('no filter after ',rowRecords);

    //     // else{
    //     //    /** Filter search */
    //     //   console.log('else filter search')
    //     // }
        

    //     /**set sort asset */
    //     // let new_asset = arrSel2  
    //     // const tempRowRecords = JSON.parse(
    //     //   JSON.stringify(new_asset)
    //     // );

    //     // new_asset = [
    //     //   ...new Set([...this.state.rowRecords, ...tempRowRecords]),
    //     // ]

    //     // tempArray = JSON.parse(JSON.stringify(this.state.set_asset));
    //     // new_asset.forEach((item) => {
    //     //     tempArray.sort((a, b) => {
    //     //       if (a.asset_id === item) return -1;
    //     //       else return 1;
    //     //     });
    //     //   });

    //     //   console.log("after set sort new_asset", new_asset);
    //     //   console.log("after tempArray", tempArray);
    //     //   this.setState({ data_asset: [...tempArray] });
        
    //   }else if(filter_search === '' && filter_confirm !== 1 && filter_act === 1){
    //     console.log('filter return no filter >>> rowRecords',rowRecords);
    //     arrSel2 = []
    //     console.log('arrReduceSel : ',arrReduceSel);
    //     console.log('filter return no filter >>> arrFilterRep',arrFilterRep);
    //     arrFilterRep.map((item) => {
    //       const tempData = JSON.parse(JSON.stringify(this.state.set_asset));
    //       filteredData2 = tempData.filter((o) =>
    //         Object.keys(o).some((k) => {
    //           return String(o[k]).toLowerCase().includes(item.toLowerCase());
    //         })
    //       );
        
    //       arrSel2.push(filteredData2[0])
    //         //i++;
    //       });

    //       console.log('filter return no filter >>> arrSel2',arrSel2);

    //       let i2 = 1
    //       arrSel2.forEach(function (element) {       
    //         element.order_no = i2;
    //         i2++;
    //       });

    //   }else{
    //     /** filter search */
    //     console.log('filter search');
    //     console.log('addSel : ',addSel);
    //     //dataSourceSel
    //     console.log("before filter search rowRecords ", this.state.rowRecords);

    //     console.log('arrConf', arrConf);
    //     console.log('filter_act', filter_act);
        


    //     // arrConf < rowRecords **** decrease
    //     //

    //     /// convert key to item ///
    //     /**this.state.rowRecords.map((item) => {
    //       const tempData = JSON.parse(JSON.stringify(this.state.set_asset));
    //       filteredData2 = tempData.filter((o) =>
    //         Object.keys(o).some((k) => {
    //           return String(o[k]).toLowerCase().includes(item.toLowerCase());
    //         })
    //       );
        
    //       arrSel2.push(filteredData2[0])
    //         //i++;
    //       });

          
    //       let i2 = 1;
    //         arrSel2.forEach(function (element) {       
    //           element.order_no = i2;
    //           i2++;
    //         });

    //       console.log('handleConf filter rowRecords arrSel2 : ',arrSel2)
    //       console.log("after filter search rowRecords ", rowRecords);**/
    //       /// end convert key to item ///

       
        
    //     /** begin confirm asset */
    //   /*const tempRowRecords = JSON.parse(
    //     JSON.stringify(this.state.selectedRowKeys)
    //   );
    //   this.setState(
    //     {
    //       rowRecords: [...this.state.rowRecords, ...tempRowRecords],
    //       selectedRowKeys: [
    //         ...new Set([...this.state.rowRecords, ...tempRowRecords]),
    //       ],
    //     },
    //     () => {
          
    //       console.log("handleConf after add row keys", this.state.selectedRowKeys);
    //       console.log("handleConf rowRecords", this.state.rowRecords);
    //       console.log("handleConf arrConf", this.state.arrConf);

    //       this.state.arrConf.map((item) => {
    //         const tempData = JSON.parse(JSON.stringify(this.state.set_asset));
    //         filteredData2 = tempData.filter((o) =>
    //           Object.keys(o).some((k) => {
    //             return String(o[k]).toLowerCase().includes(item.toLowerCase());
    //           })
    //         );
          
    //         arrSel2.push(filteredData2[0])
    //           //i++;
    //         });

    //         console.log('handleConf arrSel2 : ',arrSel2)

    //         let i2 = 1;
    //         arrSel2.forEach(function (element) {       
    //           element.order_no = i2;
    //           i2++;
    //         });
    //     }
    //   );*/
    //   /** end confirm asset */

    //   this.setState({
    //     filter_confirm : 1,
    //     conf_first: 1
    //   })
      
    //   }//end else filter search
    
    // this.setState({
    //   dataSourceSel:arrSel2,
    //   visible:false,
    //   visibleConf:true,
    //   value_state:my_val,
    //   //data_asset: [...tempArray]
    // })


  }

  handleBack = async () => {
    console.log('handleBack');
    const {
      arrReduceSel,
      filter_search,
      dataSourceSel,
      filter_confirm,
      // arrFilterRep,
      filter_act,
      // arrSel2

    } = this.state;

    if(false){

    console.log('arrReduceSel : ',arrReduceSel);
    let tempArray = [...this.state.data_asset];
    let selKeys = []



    console.log('arrReduceSel : '+arrReduceSel.length+' , filter_search : '+filter_search+' , filter_confirm : '+filter_confirm+' , filter_act : '+filter_act)
    if(filter_search === '' && filter_confirm !== 1 && filter_act === 1){
      /** filter repeat */
      console.log('filter repeat dataSourceSel:',dataSourceSel);
      dataSourceSel.forEach((item) => {
        selKeys.push(item.asset_id)
        tempArray.sort((a, b) => {
          if (a.asset_id === item.asset_id) return -1;
          else return 1;
        });
      })

      let new_temp = [...tempArray]
      console.log('search filter >> new_temp',new_temp);
      this.setState({
        data_asset: new_temp,
        selectedRowKeys : selKeys,
      });

    }else  if(arrReduceSel.length !== 0 && filter_search === '' && filter_confirm === 0){
      /** no filter */
      console.log('arrReduceSel',arrReduceSel);
      arrReduceSel.forEach((item) => {
        selKeys.push(item.asset_id)
        // console.log("forEach item", item);
        tempArray.sort((a, b) => {
          // console.log("sort a.asset_id", a.asset_id);
          // console.log("sort item", item);
          if (a.asset_id === item.asset_id) return -1;
          else return 1;
        });
      })

      let new_temp = [...tempArray]
      console.log('new_temp :',new_temp);
      this.setState({
        data_asset: new_temp,
        selectedRowKeys : selKeys,
      });


    //}//end if
    //else if(filter_search === '' && filter_confirm !== 1 && filter_act === 1){
      

    }else{
      /** search filter */
      console.log('dataSourceSel:',dataSourceSel);
      dataSourceSel.forEach((item) => {
        selKeys.push(item.asset_id)
        tempArray.sort((a, b) => {
          if (a.asset_id === item.asset_id) return -1;
          else return 1;
        });
      })

      let new_temp = [...tempArray]
      console.log('search filter >> new_temp',new_temp);
      this.setState({
        data_asset: new_temp,
        selectedRowKeys : selKeys,
      });
  
      
    }

    }

    
  }
  // handleAdd = async (values) => {
  handleAdd = async () => {
    const {
      // setDataAssign,
      // asset_multi,
      mode,
      sel_emp_service_pm_id,
      // data_asset,
      dataSourceSel,
      value_state
    } = this.state;

    let values = value_state
    console.log(values);
    let arr_sort = dataSourceSel
    arr_sort.sort(this.GetSortOrder("order_no"));

    let count_assset = 0;
    let pm_type = 1,
      start_date = "",
      end_date = "",
      checked = 0,
      employee_id = 0,
      rep_time = 0,
      rep_every = 0,
      rep_day = 0,
      cal_end = 0;

    // var date = moment(values.date).format("MM/DD/YYYY");
    if (mode === "add") {
      //let  end_date = "", checked = 0, employee_id = 0, rep_time = 0, rep_every = 0, rep_day = 0 ,cal_end = 0
      const current_date = moment().format("YYYY-MM-DD");
      if (values.select_team_emp === undefined) {
        employee_id = 0;
      } else if (values.select_team_emp !== 1) {
        employee_id = this.state.selected_emp;
      } else {
        employee_id = 0;
      }

      if (values.repeat_time === 1) {
        rep_time = 0;
        rep_every = 0;
        rep_day = 0;
      } else if (values.repeat_time === 2) {
        rep_time = 1;
        rep_every = values.repeat_every;
        rep_day = values.repeat_day;
      } else if (values.repeat_time === 3) {
        rep_time = 2;
        rep_every = values.repeat_every;
        rep_day = values.repeat_day;
      }

      if (values.start_date === undefined && values.end_date === undefined) {
        start_date = current_date;
      } else {
        start_date = moment(values.start_date).format("YYYY-MM-DD");
        end_date = moment(values.end_date).format("YYYY-MM-DD");
      }
      if (rep_day === 0) {
        cal_end = 1;
        // end_date = start_date;
        console.log(end_date);
      }

      if (rep_time === 1) {
        if (rep_day > 0 && rep_day === 1) {
          //week
          //cal_end = 7 * rep_every

          cal_end = 6;

          // end_date = moment(start_date)
          //   .add(cal_end, "days")
          //   .format("YYYY-MM-DD");
          //   console.log(end_date); 

        } else if (rep_day > 0 && rep_day === 2) {
          //month
          //cal_end = rep_every
          cal_end = 1;
          // end_date = moment(start_date).add(cal_end, "M").format("YYYY-MM-DD");
          console.log(end_date);
        } else if (rep_day > 0 && rep_day === 3) {
          //year
          cal_end = rep_every * 12;
          // end_date = moment(start_date).add(cal_end, "M").format("YYYY-MM-DD");
          console.log(end_date);

        }
      } else if (rep_time === 2) {
        let start_calendar = "",
          end_calendar = "";
        for (let j = 0; j < 7; j++) {
          let check_date = moment(start_date).add(j, "days").format("YYYY-MM-DD");
          let newDate = new Date(check_date);

          let check_date_end = moment(end_date).add(j, "days").format("YYYY-MM-DD");
          let newDateEnd = new Date(check_date_end)

          if (newDate.getDay() === 6) {
            start_calendar = newDate;
            end_calendar = moment(newDateEnd).add(1, "days").format("YYYY-MM-DD");
            break;
          } else if (newDate.getDay() === 0) {
            start_calendar = moment(newDate)
              .add(-1, "days")
              .format("YYYY-MM-DD");
            end_calendar = newDateEnd;
            break;
          }
        } //end for
        console.log(end_calendar);
        start_date = moment(start_calendar).format("YYYY-MM-DD");
        end_date = moment(end_calendar).format("YYYY-MM-DD");
      } //end if rep_time === 2

      //end_date = moment(start_date).add(7, 'days').format("YYYY-MM-DD");

      if (this.state.checked_auto) {
        checked = 1;
      } else {
        checked = 0;
      }

      if (rep_every === undefined) {
        rep_every = 1;
      }
      let temp_asset = "";
      /*if (setDataAssign !== undefined) {
        count_assset = setDataAssign.length;
        for (let i = 0; i < count_assset; i++) {
          //console.log('asset_id : ',setDataAssign[i].asset_id);
          //asset_multi.push(setDataAssign[i].asset_id)
          temp_asset += setDataAssign[i].asset_id;
          if (i !== count_assset - 1) {
            temp_asset += ",";
          }
        }
      }

      if (setDataAssign !== undefined) {
        count_assset = setDataAssign.length;
        for (let i = 0; i < count_assset; i++) {
          //console.log('asset_id : ',setDataAssign[i].asset_id);
          //asset_multi.push(setDataAssign[i].asset_id)
          temp_asset += setDataAssign[i].asset_id;
          if (i !== count_assset - 1) {
            temp_asset += ",";
          }
        }
      }*/

      if (arr_sort !== undefined) {
        count_assset = arr_sort.length;
        for (let i = 0; i < count_assset; i++) {
          //console.log('asset_id : ',setDataAssign[i].asset_id);
          //asset_multi.push(setDataAssign[i].asset_id)
          temp_asset += arr_sort[i].asset_id;
          if (i !== count_assset - 1) {
            temp_asset += ",";
          }
        }
      }

      /*if (arr_sort !== undefined) {
        count_assset = arr_sort.length;
        for (let i = 0; i < count_assset; i++) {
          //console.log('asset_id : ',setDataAssign[i].asset_id);
          //asset_multi.push(setDataAssign[i].asset_id)
          temp_asset += arr_sort[i].asset_id;
          if (i !== count_assset - 1) {
            temp_asset += ",";
          }
        }
      }*/
      let asset_code_id = null;
      if (count_assset > 1) {
        pm_type = 2;
        asset_code_id = "";
      } else {
        pm_type = 1;
        asset_code_id = temp_asset;
      }

      if(values){
          console.log(values);
      }


      let DataSet = {}
      if(checked){
        DataSet = {
          company_id: Cookies.get("companyid"),
          operator_id: Cookies.get("operator_id"),
          project_id: Cookies.get("project_id"),
          emp_service_pm_id: "",
          job_category_id: values.job_category,
          job_type_id: values.job_type_id,
          job_sub_type_id: values.job_sub_type_id,
          //asset_id: values.as_code,
          asset_id: asset_code_id,
          // team_group_id: values.select_team,
          // team_id: values.select_team,
          team_group_id: null,
          team_id: null,
          employee_id: employee_id,
          emp_work_pm_start: start_date,
          emp_work_pm_end: end_date,
          auto_gen_job: checked,
          is_approve: 1,
          repeat_time: rep_time,
          repeat_every: rep_every,
          repeat_day: rep_day,
          approve_by: Cookies.get("userId"),
          create_date: current_date,
          create_by: Cookies.get("userId"),
          update_date: "",
          update_by: "",
          delete_date: "",
          delete_by: "",
          pm_type: pm_type,
          multi_asset: temp_asset,
          plan_name: values.plan_name,
          group_id: values.group_id ? values.group_id : null ,
          group_name:values.group_name ? values.group_name : null ,
        };
        
      }else{
        DataSet = {
          company_id: Cookies.get("companyid"),
          operator_id: Cookies.get("operator_id"),
          project_id: Cookies.get("project_id"),
          emp_service_pm_id: "",
          job_category_id: values.job_category,
          job_type_id: values.job_type_id,
          job_sub_type_id: values.job_sub_type_id,
          //asset_id: values.as_code,
          asset_id: asset_code_id,
          // team_group_id: values.select_team,
          // team_id: values.select_team,
          team_group_id: null,
          team_id: null,
          employee_id: employee_id,
          emp_work_pm_start: start_date,
          emp_work_pm_end: end_date,
          auto_gen_job: checked,
          is_approve: 1,
          approve_by: Cookies.get("userId"),
          create_date: current_date,
          create_by: Cookies.get("userId"),
          update_date: "",
          update_by: "",
          delete_date: "",
          delete_by: "",
          pm_type: pm_type,
          multi_asset: temp_asset,
          plan_name: values.plan_name,
          group_id: values.group_id ? values.group_id : null ,
          group_name:values.group_name ? values.group_name : null ,
        };
      }

      console.log(DataSet);

      //add to api
      const res_add_job = await Api.post("v2/update_emp_service_pm", DataSet);
      let var_time = 0,
          var_every = 0,
          var_day = 0;
      let init = {};
      if (this.formRef.current !== null) {
        var_time = "";
        var_every = 1;
        var_day = "";
        init = {
          repeat_time: var_time,
          repeat_every: var_every,
          repeat_day: var_day,
          // search_asset: "",//
        };
        this.formRef.current.setFieldsValue(init);
        this.formRef.current.resetFields();
      } else {
        var_time = "";
        var_every = 1;
        var_day = "";
        init = {
          repeat_time: var_time,
          repeat_every: var_every,
          repeat_day: var_day,
          // search_asset: "",//
        };
      }
      // this.formRef.current.resetFields();

      for (let i = 0; i < this.state.set_asset.length; i++) {
        this.state.set_asset[i]["status_checkbox"] = false
      }

      this.setState({
        data_init: init,
        visible: false,
        visible_success: true,
        checked_auto:false,//
        filter_search:'',
        tempMulti:[],
        data_asset:this.state.set_asset
      });
    } else {
      //edit
      // let start_date = "", end_date = "", checked = 0, employee_id = 0, rep_time = 0, rep_every = 0, rep_day = 0 ,cal_end = 0
      const current_date = moment().format("YYYY-MM-DD");

      if (values.select_team_emp === undefined) {
        employee_id = 0;
      } else if (values.select_team_emp !== 1) {
        //employee_id = values.employee
        employee_id = this.state.selected_emp;
      } else {
        employee_id = 0;
      }

      if (values.repeat_time === 1) {
        rep_time = 0;
        rep_every = 0;
        rep_day = 0;
      } else if (values.repeat_time === 2) {
        rep_time = 1;
        rep_every = values.repeat_every;
        rep_day = values.repeat_day;
      } else if (values.repeat_time === 3) {
        rep_time = 2;
        rep_every = values.repeat_every;
        rep_day = values.repeat_day;
      }

      if (values.start_date === undefined) {
        start_date = moment(this.state.startDate).format("YYYY-MM-DD");
      } else {
        start_date = moment(values.start_date).format("YYYY-MM-DD");
      }
      if (rep_day === 0) {
        cal_end = 1;
        end_date = start_date;
      }

      if (rep_time === 1) {
        if (rep_day > 0 && rep_day === 1) {
          //week
          //cal_end = 7 * rep_every
          cal_end = 6;
          end_date = moment(start_date)
            .add(cal_end, "days")
            .format("YYYY-MM-DD");
        } else if (rep_day > 0 && rep_day === 2) {
          //month
          //cal_end = rep_every
          cal_end = 1;
          end_date = moment(start_date).add(cal_end, "M").format("YYYY-MM-DD");
        } else if (rep_day > 0 && rep_day === 3) {
          //year
          cal_end = rep_every * 12;
          end_date = moment(start_date).add(cal_end, "M").format("YYYY-MM-DD");
        }
      } else if (rep_time === 2) {
        let start_calendar = "",
          end_calendar = "";
        for (let j = 0; j < 7; j++) {
          let check_date = moment(start_date)
            .add(j, "days")
            .format("YYYY-MM-DD");
          let newDate = new Date(check_date);
          if (newDate.getDay() === 6) {
            start_calendar = newDate;
            end_calendar = moment(newDate).add(1, "days").format("YYYY-MM-DD");
            break;
          } else if (newDate.getDay() === 0) {
            start_calendar = moment(newDate)
              .add(-1, "days")
              .format("YYYY-MM-DD");
            end_calendar = newDate;
            break;
          }
        } //end for
        start_date = moment(start_calendar).format("YYYY-MM-DD");
        end_date = moment(end_calendar).format("YYYY-MM-DD");
      } //end if rep_time === 2

      //end_date = moment(start_date).add(7, 'days').format("YYYY-MM-DD");

      if (this.state.checked_auto) {
        checked = 1;
      } else {
        checked = 0;
      }

      if (rep_every === undefined) {
        rep_every = 1;
      }
      let temp_asset = "";

      /*if (setDataAssign !== undefined) {
        count_assset = setDataAssign.length;
        for (let i = 0; i < count_assset; i++) {
          //console.log('asset_id : ',setDataAssign[i].asset_id);
          //asset_multi.push(setDataAssign[i].asset_id)
          temp_asset += setDataAssign[i].asset_id;
          if (i !== count_assset - 1) {
            temp_asset += ",";
          }
        }
      } else {
        //setDataAssign
        temp_asset = this.state.sel_multi_asset;
        count_assset = this.state.sel_count_multi;
      }*/


      if (arr_sort !== undefined) {
        count_assset = arr_sort.length;
        for (let i = 0; i < count_assset; i++) {
          //console.log('asset_id : ',setDataAssign[i].asset_id);
          //asset_multi.push(setDataAssign[i].asset_id)
          temp_asset += arr_sort[i].asset_id;
          if (i !== count_assset - 1) {
            temp_asset += ",";
          }
        }
      } else {
        //setDataAssign
        temp_asset = this.state.sel_multi_asset;
        count_assset = this.state.sel_count_multi;
      }

      let asset_code_id = "";
      if (count_assset > 1) {
        pm_type = 2;
        asset_code_id = null;
      } else {
        pm_type = 1;
        asset_code_id = temp_asset;
      }

      // if(checked){
        let DataSet = {}
        if(checked){
          DataSet = {
            company_id: Cookies.get("companyid"),
            operator_id: Cookies.get("operator_id"),
            project_id: Cookies.get("project_id"),
            emp_service_pm_id: sel_emp_service_pm_id,
            job_category_id: values.job_category,
            job_type_id: values.job_type_id,
            job_sub_type_id: values.job_sub_type_id,
            asset_id: asset_code_id,
            // team_group_id: values.select_team,
            // team_id: values.select_team,
            team_group_id: null,
            team_id: null,
            employee_id: employee_id,
            emp_work_pm_start: start_date,
            emp_work_pm_end: end_date,
            auto_gen_job: checked,
            is_approve: 1,
            repeat_time: rep_time,
            repeat_every: rep_every,
            repeat_day: rep_day,
            approve_by: Cookies.get("userId"),
            // create_date: current_date,
            // create_by: Cookies.get("userId"),
            update_date: current_date,
            update_by: Cookies.get("userId"),
            delete_date: "",
            delete_by: "",
            pm_type: pm_type,
            multi_asset: temp_asset,
            plan_name: values.plan_name,
            group_id: values.group_id ? values.group_id : null ,
            group_name:values.group_name ? values.group_name : null ,
          };
    }else{
            DataSet = {
              company_id: Cookies.get("companyid"),
              operator_id: Cookies.get("operator_id"),
              project_id: Cookies.get("project_id"),
              emp_service_pm_id: sel_emp_service_pm_id,
              job_category_id: values.job_category,
              job_type_id: values.job_type_id,
              job_sub_type_id: values.job_sub_type_id,
              asset_id: asset_code_id,
              // team_group_id: values.select_team,
              // team_id: values.select_team,
              team_group_id: null,
              team_id: null,
              employee_id: employee_id,
              emp_work_pm_start: start_date,
              emp_work_pm_end: end_date,
              auto_gen_job: checked,
              is_approve: 1,
              // repeat_time: null,
              // repeat_every: null,
              // repeat_day: null,
              approve_by: Cookies.get("userId"),
              // create_date: current_date,
              // create_by: Cookies.get("userId"),
              update_date: current_date,
              update_by: Cookies.get("userId"),
              delete_date: "",
              delete_by: "",
              pm_type: pm_type,
              multi_asset: temp_asset,
              plan_name: values.plan_name,
              group_id: values.group_id ? values.group_id : null ,
              group_name:values.group_name ? values.group_name : null ,
            };
    }

      //update to api
      const res_edit_job = await Api.post(
        "v2/update_emp_service_pm_by_id",
        DataSet
      );
      let var_time = 0,
        var_every = 0,
        var_day = 0;
      let init = {};
      if (this.formRef.current !== null) {
        var_time = "";
        var_every = 1;
        var_day = "";
        init = {
          repeat_time: var_time,
          repeat_every: var_every,
          repeat_day: var_day,
          // search_asset: "",//
        };
        this.formRef.current.setFieldsValue(init);
        this.formRef.current.resetFields();
      } else {
        var_time = "";
        var_every = 1;
        var_day = "";
        init = {
          repeat_time: var_time,
          repeat_every: var_every,
          repeat_day: var_day,
          // search_asset: "",//
        };
      }

      // this.formRef.current.resetFields();
      for (let i = 0; i < this.state.set_asset.length; i++) {
        this.state.set_asset[i]["status_checkbox"] = false
      }

      this.setState({
        data_init: init,
        visible: false,
        visible_success: true,
        disabled_repeat: false,
        checked_auto:false,//
        data_asset:this.state.set_asset,
        filter_search:'',
        tempMulti:[],
      });
    } //end else

    //reload Data
    // const calendar_list = await Api.post("planningJobCalendarList", {
    //   work_pm_start: moment(start_date).format("YYYY-MM-DD"),
    //   company_id: Cookies.get("companyid"),
    // });

    // this.setState({
    //   list: calendar_list.data.data,
    //   events : [],
    // })

    const startOfMonth = moment().startOf("month").format("YYYY-MM-DD");
    const endOfMonth = moment().endOf("month").format("YYYY-MM-DD");
    const job_calendar = await Api.post("v2/jobEmployeeCalender", {
      company_id: Cookies.get("companyid"),
      operator_id: Cookies.get("operator_id"),
      project_id: Cookies.get("project_id"),
      work_pm_start: startOfMonth,
      work_pm_end: endOfMonth,
      group_id: values.group_id ? values.group_id : null ,
      group_name:values.group_name ? values.group_name : null ,
    });

    const job_calendar1 = await Api.post("v2/jobEmployeeCalender", {
      company_id: Cookies.get("companyid"),
      operator_id: Cookies.get("operator_id"),
      project_id: Cookies.get("project_id"),
      auto_gen_job:  (this.state.tab_auto === 0 ? 1:0),
      work_pm_start: startOfMonth,
      work_pm_end: endOfMonth,
      group_id: values.group_id ? values.group_id : null ,
      group_name:values.group_name ? values.group_name : null ,
    });

    this.setState({
      list: job_calendar1.data.data,
      events: [],
    });

    for (let i = 0; i < job_calendar.data.data.length; i++) {
      let title = "";
      let s_date = job_calendar.data.data[i].emp_work_pm_start;
      let e_date = job_calendar.data.data[i].emp_work_pm_end;

      let repeat_time = job_calendar.data.data[i].repeat_time;
      // let repeat_every = job_calendar.data.data[i].repeat_every;
      // let repeat_day = job_calendar.data.data[i].repeat_day;

      //console.log('job_calendar',job_calendar.data.data[i]);
      if (
        job_calendar.data.data[i].emp_id === null &&
        job_calendar.data.data[i].team_id === 0
      ) {
        //console.log(i+' asset_code : '+job_calendar.data.data[i].asset_code);
        if (
          job_calendar.data.data[i].asset_code !== "" &&
          job_calendar.data.data[i].asset_code !== null
        ) {
          //title = job_calendar.data.data[i].asset_code
          title = job_calendar.data.data[i].plan_name;
        } else {
          //title = "Asset List (ID:"+job_calendar.data.data[i].emp_service_pm_id+")"
          title = job_calendar.data.data[i].plan_name;
        }
      } else if (
        job_calendar.data.data[i].emp_id !== null &&
        job_calendar.data.data[i].team_id === 0
      ) {
        title = job_calendar.data.data[i].emp_name;
      } else if (
        job_calendar.data.data[i].emp_id === null &&
        job_calendar.data.data[i].team_id !== 0
      ) {
        title = job_calendar.data.data[i].team_name;
      } else if (
        job_calendar.data.data[i].emp_id !== null &&
        job_calendar.data.data[i].team_id !== 0
      ) {
        title = job_calendar.data.data[i].emp_name;
      }

      if (repeat_time === 1) {
        /** display mon-fri only */
        let start_calendar = "",
          end_calendar = "";
        for (let j = 0; ; j++) {
          let check_date = moment(s_date).add(j, "days").format("YYYY-MM-DD");
          //console.log('day : '+check_date.day());
          let newDate = new Date(check_date);

          if (
            start_calendar === "" &&
            newDate.getDay() !== 0 &&
            newDate.getDay() !== 6
          ) {
            start_calendar = newDate;
            end_calendar = newDate;
          }
          if (
            start_calendar !== "" &&
            newDate.getDay() !== 0 &&
            newDate.getDay() !== 6
          ) {
            end_calendar = newDate;
          } else {
            this.state.events.push({
              start: start_calendar,
              end: end_calendar,
              title: title,
              item: job_calendar.data.data[i],
            });

            start_calendar = "";
            end_calendar = "";
          }
          //console.log('check_date : '+check_date);

          if (moment(check_date).isSame(moment(e_date).format("YYYY-MM-DD"))) {
            if (newDate.getDay() !== 0 && newDate.getDay() !== 6) {
              this.state.events.push({
                start: start_calendar,
                end: end_calendar,
                title: title,
                item: job_calendar.data.data[i],
              });
            }
            break;
          }
        } //end for
      } else if (repeat_time === 2) {
        /** display sat , sun only */
        let start_calendar = "",
          end_calendar = "";
        for (let j = 0; ; j++) {
          let check_date = moment(s_date).add(j, "days").format("YYYY-MM-DD");
          let newDate = new Date(check_date);
          if (
            start_calendar === "" &&
            newDate.getDay() !== 1 &&
            newDate.getDay() !== 2 &&
            newDate.getDay() !== 3 &&
            newDate.getDay() !== 4 &&
            newDate.getDay() !== 5
          ) {
            start_calendar = newDate;
            end_calendar = newDate;
          }

          if (
            start_calendar !== "" &&
            newDate.getDay() !== 1 &&
            newDate.getDay() !== 2 &&
            newDate.getDay() !== 3 &&
            newDate.getDay() !== 4 &&
            newDate.getDay() !== 5
          ) {
            end_calendar = newDate;
          } else {
            this.state.events.push({
              start: start_calendar,
              end: end_calendar,
              title: title,
              item: job_calendar.data.data[i],
            });

            start_calendar = "";
            end_calendar = "";
          }

          if (moment(check_date).isSame(moment(e_date).format("YYYY-MM-DD"))) {
            if (
              newDate.getDay() !== 1 &&
              newDate.getDay() !== 2 &&
              newDate.getDay() !== 3 &&
              newDate.getDay() !== 4 &&
              newDate.getDay() !== 5
            ) {
              this.state.events.push({
                start: start_calendar,
                end: end_calendar,
                title: title,
                item: job_calendar.data.data[i],
              });
            }
            break;
          }
        } //end for
      } else {
        /** repeat_time === 0 */
        /*let check_y_date =  moment(s_date).format("YYYY");
      let check_m_date =  moment(s_date).format("MM");
      let check_d_date =  moment(s_date).format("DD");
      let newDate = new Date(check_y_date, check_m_date, check_d_date)

      let end_y_date =  moment(e_date).format("YYYY");
      let end_m_date =  moment(e_date).format("MM");
      let end_d_date =  moment(e_date).format("DD");
      let newEndDate = new Date(end_y_date, end_m_date, end_d_date)
      */

        let check_date = moment(s_date).format("YYYY-MM-DD");
        let newDate = new Date(check_date);

        let end_date = moment(e_date).format("YYYY-MM-DD");
        let newEndDate = new Date(end_date);

        this.state.events.push({
          start: newDate,
          end: newEndDate,
          title: title,
          item: job_calendar.data.data[i],
        });
      }
    } //end for

    /*values.ma_period.filter((item) => {
      item = item.split("-");
      var start = date + " " + item[0];
      var end = date + " " + item[1];
      var events = this.state.events;
      events.push({
        start: new Date(start),
        end: new Date(end),
        title: values.maintenance_name + " (Asset: " + values.asset_code + ")",
      });
      this.setState({ events });
    });*/
  };

  renderSuccess() {
    const { mode, visible_success } = this.state;
    return (
      <Modal
        title={null}
        centered
        visible={visible_success}
        footer={null}
        closable={false}
      >
        <div className="text-center">
          <img
            src={ChangePath.absoluteUrl("/img/modal_approve.svg")}
            className="img-fluid"
          />
          <h3 className="font-mont-sb font18 c-blue mt-3">
            {mode === "add" ? "Add" : mode} Planning Success
          </h3>
          <button
            onClick={() => {
              this.setState({ visible_success: false, visibleConf:false,currentPage: 1,value_state:{} });
            }}
            className="btn btn-secondary"
          >
            OK
          </button>
        </div>
      </Modal>
    );
  }

  onChangeasset = async (name, value, item) => {
    // console.log(name);
    // console.log(value);
    // console.log(item.obj);
    //asset_id
    let init = [];
    this.state.form[name] = value;
    switch (name) {
      case "job_category_id":
        const get_job_type = await Api.post("get_job_type", {
          pk_id: null,
          fk_id: value,
          is_active: "1",
          effective: "1",
          company_id: Cookies.get("companyid"),
          operator_id: Cookies.get("operator_id"),
          project_id: Cookies.get("project_id"),
          sql_where: null,
        });
        init = {
          job_type_id: "",
          job_sub_type_id: "",
        };

        if (this.formRef.current !== null) {
          this.formRef.current.setFieldsValue(init);
        }

        return this.setState({
          data_init: init,
          //job_type: get_job_type.data.data.job_type_dto_list,
          job_type: get_job_type.data.data,
        });
      case "job_type":
        const get_sub_type = await Api.post("get_job_sub_type", {
          operator_id: Cookies.get("operator_id"),
          project_id: Cookies.get("project_id"),
          job_sub_type_id: null,
          job_category_id: this.state.form["job_category_id"],
          job_type_id: value,
          is_active: 1,
          effective: 1,
          sql_where: " and company_id=" + Cookies.get("companyid"),
          //sql_where: null,
        });

        init = {
          job_sub_type_id: "",
        };

        if (this.formRef.current !== null) {
          this.formRef.current.setFieldsValue(init);
        }

        return this.setState({
          data_init: init,
          job_sub_type: get_sub_type.data.data.job_sub_type_dto_list,
        });
      case "team_emp":
        switch (value) {
          case 1:
            return this.setState({
              fact_team: true,
              fact_emp: false,
            });
          case 2:
            return this.setState({
              fact_emp: true,
              fact_team: false,
            });
          default:
            return null;
        }
      case "employee":
        return this.setState({
          selected_emp: value,
        });
      case "repeat_time":
        let dis_repeat = false;
        if (value === 1) {
          dis_repeat = true;
        } else {
          dis_repeat = false;
        }

        init = {
          repeat_day: 1,
        };

        if (this.formRef.current !== null) {
          this.formRef.current.setFieldsValue(init);
        }

        return this.setState({
          data_init: init,
          disabled_repeat: dis_repeat,
        });
      case "group_name":
        // const get_planning_group = await Api.post("get_planning_group", {
        //     company_id: Cookies.get("companyid")
        //   ,operator_id: Cookies.get("operator_id")
        //   ,project_id: Cookies.get("project_id")
        //   ,is_active: 1
        //   ,group_id: value
        //   // ,group_name: value.obj.group_name
        // });
        // console.log(get_planning_group.data.data.result);
        // if(get_planning_group.data.result.code.toLowerCase() == "p"){
        //   if (this.formRef.current != null) {
        //     return this.formRef.current.setFieldsValue({
        //         group_id: get_planning_group.data.data.result[0].group_id,
        //         group_name:get_planning_group.data.data.result[0].group_name
        //       });
        //   }
        // }
              return this.formRef.current.setFieldsValue({
                  group_id: item.obj.group_id,
                  group_name: item.obj.group_name,
                });
        default:
        return null;
    }
  };

  editPlan = async (data) => {
    // console.log(data);
    const { setDataAssign , filter_search } = this.state;
    
    let arrSel = []
    let arrSel2 = []
    let filteredData2 = []

    const s_date = new Date(data.emp_work_pm_start);
    let multi = [];
    let filteredData = {};
    let count_multi = 0;
    let tempArray = [...this.state.data_asset];
    if (data.multi_asset !== null) {
      multi = data.multi_asset.split(",");
      count_multi = multi.length;

      /** clear array */
      this.state.data_asset.map((item) => {
        item.status_checkbox = false
      })
      
      /** set asset */
      this.state.data_asset.forEach((item) => {
        multi.map((item2) => {
            if(item.asset_id === item2){
              item.status_checkbox = true
            }
        })
      });

      this.setState({
        bk_data_asset : this.state.data_asset,
        bk_set_asset : this.state.data_asset,
        checkboxAll:false
      })

      multi.map((item) => {
        //console.log(i+' >> map : '+item);
      const tempData = JSON.parse(JSON.stringify(this.state.set_asset));
      filteredData = tempData.filter((o) =>
        Object.keys(o).some((k) => {
          return String(o[k]).toLowerCase().includes(item.toLowerCase());
        })
      );

      arrSel.push(filteredData[0])
        //i++;
      });

      // let i = 1;
      // arrSel.forEach(function (element) {       
      //   element.order_no = i;
      //   i++;
      // });


      /** begin confirm asset */
      const tempRowRecords = JSON.parse(
        JSON.stringify(this.state.selectedRowKeys)
      );
      this.setState(
        {
          rowRecords: [...this.state.rowRecords, ...tempRowRecords],
          selectedRowKeys: [
            ...new Set([...this.state.rowRecords, ...tempRowRecords]),
          ],
        },
        () => {

          this.state.selectedRowKeys.map((item) => {
            const tempData = JSON.parse(JSON.stringify(this.state.set_asset));
            filteredData2 = tempData.filter((o) =>
              Object.keys(o).some((k) => {
                return String(o[k]).toLowerCase().includes(item.toLowerCase());
              })
            );
          
            arrSel2.push(filteredData2[0])
              //i++;
            });

            let i2 = 1;
            arrSel2.forEach(function (element) {       
              element.order_no = i2;
              i2++;
            });
        }
      );
      /** end confirm asset */

      //console.log('editPlan selectedRowKeys : ',this.state.selectedRowKeys)
      (multi.length > this.state.selectedRowKeys.length
        ? multi
        : this.state.selectedRowKeys
      ).forEach((item) => {
        tempArray.sort((a, b) => {
          if (a.asset_id === item) return -1;
          else return 1;
        });
      });

    } else {
      multi = [];
    }

    let new_temp = [...tempArray]

    this.setState({
      sel_multi_asset: data.multi_asset,
      sel_count_multi: count_multi,
      data_asset: new_temp,
      //dataSourceSel:arrSel,
      dataSourceSel:arrSel2,
      arrConf:multi,
    });

    const get_job_type = await Api.post("get_job_type", {
      pk_id: null,
      fk_id: data.job_category_id,
      is_active: "1",
      effective: "1",
      company_id: Cookies.get("companyid"),
      operator_id:  Cookies.get("operator_id"),
      project_id: Cookies.get("project_id"),
      sql_where: null,
    });

    const get_sub_type = await Api.post("get_job_sub_type", {
      job_sub_type_id: null,
      job_category_id: data.job_category_id,
      job_type_id: data.job_type_id,
      operator_id:  Cookies.get("operator_id"),
      project_id: Cookies.get("project_id"),
      is_active: 1,
      effective: 1,
      sql_where: " and company_id=" + Cookies.get("companyid"),
      //sql_where: null,
    });


    let repeat_time = data.repeat_time;
    let repeat_every = data.repeat_every;
    let repeat_day = data.repeat_day;
    //let init = []

    repeat_time += 1;
    if (repeat_every === 0) {
      repeat_every = 1;
    }
    if (repeat_day === 0) {
      repeat_day = 1;
    }

    let dis_repeat = false
    let dis_rep_time = false;

    let check_auto = false;
    if(data.auto_gen_job === 1){
      check_auto = true
      dis_repeat = false
      dis_rep_time = false
    }else{
      check_auto = false
      repeat_time = 1
      repeat_every = 1
      repeat_day = 1
      dis_repeat = true
      dis_rep_time = true
    }


    //checked_auto

    let init = {
      plan_name: data.plan_name,
      job_category: data.job_category_id,
      job_type_id: data.job_type_id,
      job_sub_type_id: data.job_sub_type_id,
      repeat_time: repeat_time,
      repeat_every: repeat_every,
      repeat_day: repeat_day,
      group_id: data.group_id,
      group_name: data.group_name,
      //maintenance_name: 
    };

    if (this.formRef.current !== null) {
      this.formRef.current.setFieldsValue(init);
    }


    this.setState({
      mode: "Edit",
      data_init: init,
      startDate: s_date,
      selectedRowKeys: multi,
      tempMulti: multi,
      visible: true,
      job_type: get_job_type.data.data,
      job_sub_type: get_sub_type.data.data.job_sub_type_dto_list,
      sel_emp_service_pm_id: data.emp_service_pm_id,
      checked_auto:check_auto,
      disabled_repeat: dis_repeat,
      disabled_repeat_time: dis_rep_time,
      filter_search:''
    });
  };

  selectCalendar = async (event) => {
    console.log(event);
    const { setDataAssign, set_asset , selectedRows , data_asset , filter_search } = this.state;
    let arrSel = []
    let arrSel2 = []

    this.setState({
      filter_search:''
    })

    
    //console.log("selectCalendar data_asset"+JSON.stringify(data_asset));

    //console.log("selectCalendar selectedRows", selectedRows);
    //selectedRowKeys

    // this.formRef.current.setFieldsValue({
    //   repeat_time: event.item.repeat_time
    // });
    // const s_date = moment(event.item.emp_work_pm_start).format("YYYY-MM-DD")
    const s_date = new Date(event.item.emp_work_pm_start);
    let multi = [];
    let filteredData = {};
    let filteredData2 = [];
    let count_multi = 0;
    let tempArray = [...this.state.data_asset];

    if (event.item.multi_asset !== null) {
      multi = event.item.multi_asset.split(",");
      count_multi = multi.length;
      

      // const found = this.state.data_asset.some(r=> {
      //   multi.includes(r)
      // })

      /** clear array */
      this.state.data_asset.map((item) => {
        item.status_checkbox = false
      })
      // this.state.set_asset.map((item) => {
      //   item.status_checkbox = false
      // })
      
      /** set asset */
      this.state.data_asset.forEach((item) => {
        multi.map((item2) => {
            if(item.asset_id === item2){
              item.status_checkbox = true
            }
        })
     
        // if(multi.includes(item)){
        //   item.status_checkbox = true
        // }
        
        // let existData = multi.filter((o) =>
        //     Object.keys(o).some((k) => {
        //     return String(o[k]).toLowerCase().includes(item.toLowerCase());
        //     })
        //   )
          

        // if (a.asset_id === item) return -1;
      //     else return 1;
      });

      // this.state.set_asset.forEach((item) => {
      //   multi.map((item2) => {
      //       if(item.asset_id === item2){
      //         item.status_checkbox = true
      //       }
      //   })
      // });



      // (multi.length > this.state.selectedRowKeys.length
      //   ? multi
      //   : this.state.selectedRowKeys
      // ).forEach((item) => {

      //   tempArray.sort((a, b) => {
      //     if (a.asset_id === item) return -1;
      //     else return 1;
      //   });
      // });

      this.setState({
        bk_data_asset : this.state.data_asset,
        bk_set_asset : this.state.data_asset,
        checkboxAll:false,
        filter_search:''
      })


      multi.map((item) => {

      const tempData = JSON.parse(JSON.stringify(this.state.set_asset));
      //console.log("tempData", tempData);
      //console.log("filterrrr", this.state.setDataAssign);
      filteredData = tempData.filter((o) =>
        Object.keys(o).some((k) => {
          return String(o[k]).toLowerCase().includes(item.toLowerCase());
        })
      );

      arrSel.push(filteredData[0])
        //i++;
      });



      /*let i = 1;
      arrSel.forEach(function (element) {       
        element.order_no = i;
        i++;
      });*/

      //console.log('arrSel'+JSON.stringify(arrSel));

      /** begin confirm asset */
      const tempRowRecords = JSON.parse(
        JSON.stringify(this.state.selectedRowKeys)
      );
      this.setState(
        {
          rowRecords: [...this.state.rowRecords, ...tempRowRecords],
          selectedRowKeys: [
            ...new Set([...this.state.rowRecords, ...tempRowRecords]),
          ],
        },
        () => {
          
          this.state.selectedRowKeys.map((item) => {
            const tempData = JSON.parse(JSON.stringify(this.state.set_asset));
            filteredData2 = tempData.filter((o) =>
              Object.keys(o).some((k) => {
                return String(o[k]).toLowerCase().includes(item.toLowerCase());
              })
            );
          
            arrSel2.push(filteredData2[0]) 
              //i++;
            });
            let i2 = 1; 
            arrSel2.forEach(function (element) {       

              element.order_no = i2;
              i2++;
            });
        }
      );
      /** end confirm asset */

      await (multi.length > this.state.selectedRowKeys.length
        ? multi
        : this.state.selectedRowKeys
      ).forEach((item) => {
        tempArray.sort((a, b) => {
          if (a.asset_id === item) {

            return -1;
          } else {

            return 1;
          }
        });


      });
      this.setState({ data_asset: [...tempArray] }, () => {
      });
    } else {
      multi = [];
    }
    
    this.setState({
      sel_multi_asset: event.item.multi_asset,
      sel_count_multi: count_multi,
      //dataSourceSel:arrSel,
      dataSourceSel:arrSel2,
      arrConf:multi,
      filter_search:''
    });

    const get_job_type = await Api.post("get_job_type", {
      pk_id: null,
      fk_id: event.item.job_category_id,
      is_active: "1",
      effective: "1",
      company_id: Cookies.get("companyid"),
      operator_id:  Cookies.get("operator_id"),
      project_id: Cookies.get("project_id"),
      sql_where: null,
    });

    const get_sub_type = await Api.post("get_job_sub_type", {
      job_sub_type_id: null,
      job_category_id: event.item.job_category_id,
      job_type_id: event.item.job_type_id,
      operator_id:  Cookies.get("operator_id"),
      project_id: Cookies.get("project_id"),
      is_active: 1,
      effective: 1,
      sql_where: " and company_id=" + Cookies.get("companyid"),
      //sql_where: null,
    });



    // const get_planning_group = await Api.post("get_planning_group", {
    //   company_id: Cookies.get("companyid")
    //   ,operator_id: Cookies.get("operator_id")
    //   ,project_id: Cookies.get("project_id")
    //   ,is_active: 1
    //   ,group_id: event.item.group_id
    //   ,group_name: event.item.group_name
    // }); 

    let repeat_time = event.item.repeat_time;
    let repeat_every = event.item.repeat_every;
    let repeat_day = event.item.repeat_day;
    //let init = []

    repeat_time += 1;
    if (repeat_every === 0) {
      repeat_every = 1;
    }
    if (repeat_day === 0) {
      repeat_day = 1;
    }

    let check_auto = false;
    let dis_repeat = false
    let dis_rep_time = false;
    //event.item
    if(event.item.auto_gen_job === 1){
      check_auto = true
      dis_repeat = false
      dis_rep_time = false
    }else{
      check_auto = false
      dis_repeat = true
      dis_rep_time = true
    }
    

    let init = {
      plan_name: event.item.plan_name,
      job_category: event.item.job_category_id,
      job_type_id: event.item.job_type_id,
      job_sub_type_id: event.item.job_sub_type_id,
      planning_group: event.item.group_id,
      repeat_time: repeat_time,
      repeat_every: repeat_every,
      repeat_day: repeat_day,
    };

    if (this.formRef.current !== null) {
      this.formRef.current.setFieldsValue(init);
    }

    //this.formRef.current.setFieldsValue(init)

    this.setState({
      mode: "Edit",
      data_init: init,
      //disabled_repeat: false,
      startDate: s_date,
      selectedRowKeys:
        multi.length > this.state.selectedRowKeys.length
          ? multi
          : this.state.selectedRowKeys,
      tempMulti: multi,
      visible: true,
      job_type: get_job_type.data.data,
      job_sub_type: get_sub_type.data.data.job_sub_type_dto_list,
      // plan_group: plan_group_list.data.list_planning_group,
      sel_emp_service_pm_id: event.item.emp_service_pm_id,
      checked_auto:check_auto,
      disabled_repeat: dis_repeat,
      disabled_repeat_time: dis_rep_time,
      filter_search:''
    });
  };

  onChangeCheck = (e) => {

    let dis_repeat = false;
    let dis_rep_time = false;
    let rep_time = ''
    let rep_day = ''
    if(e.target.checked === false){
      dis_repeat = true;
      dis_rep_time = true;
      rep_time = 1
      rep_day = 1
    }else{
      dis_repeat = false;
      dis_rep_time = false;
      rep_time = ''
      rep_day = ''
    }

    let init = {
      repeat_time : rep_time,
      repeat_day: rep_day,
    };

    if (this.formRef.current !== null) {
      this.formRef.current.setFieldsValue(init);
    }

    this.setState({
      checked_auto: e.target.checked,
      data_init: init,
      disabled_repeat: dis_repeat,
      disabled_repeat_time: dis_rep_time
    });


  };

  onFilter(value) {

      if(true){

        let temp_asset = this.state.set_asset

        if(value === "")
        {
          /** clear array */
          temp_asset.map((item) => {
            item.status_checkbox = false
          })
          
          /** sort select asset */
          this.state.tempMulti.forEach((item) => {
            temp_asset.sort((a, b) => {
                  if (a.asset_id === item) {
                    //item.status_checkbox = true
                    return -1;
                  } else {
                    return 1;
                  }
                });
          });

          /** set select asset */
          temp_asset.forEach((item) => {
            this.state.tempMulti.map((item2) => {
                if(item.asset_id === item2){
                  item.status_checkbox = true
                }
            })
          });
          
          // console.log('after this.state.tempMulti', this.state.tempMulti);
          // console.log('after temp_asset', temp_asset);

          this.setState(
            {
              data_asset: temp_asset
            }
          );

        }else{
          /** filter search */
          let filteredData = {};
          const tempData = JSON.parse(JSON.stringify(this.state.set_asset));
          //console.log("filterrrr value", this.state.setDataAssign);
          filteredData = tempData.filter((o) =>
            Object.keys(o).some((k) => {
              return String(o[k]).toLowerCase().includes(value.toLowerCase());
            })
          );

          /** clear array */
          filteredData.map((item) => {
            item.status_checkbox = false
          })

          /** sort select asset */
          // this.state.tempMulti.forEach((item) => {
          //   filteredData.sort((a, b) => {
          //         if (a.asset_id === item) {
          //           //item.status_checkbox = true
          //           return -1;
          //         } else {
          //           // console.log('1')
          //           return 1;
          //         }
          //       });
          // });

          /** set select asset */
          filteredData.forEach((item) => {
            this.state.tempMulti.map((item2) => {
                if(item.asset_id === item2){
                  item.status_checkbox = true
                }
            })
          });


          //หาตัว intersect ระหว่าง filteredData กับ data_asset

          this.setState(
            {
              data_asset: filteredData
            }
          );

          // const tempArray = JSON.parse(JSON.stringify(this.state.data_asset));
          // this.state.tempMulti.forEach((item) => {
          //   tempArray.sort((a, b) => {
          //     if (a.asset_id === item) return -1;
          //     else return 1;
          //   });
          // });
         
          

          // this.setState({ data_asset: [...tempArray]);

        }

      //   const filteredWarehouse = this.state.set_asset.filter((o) =>
      //   Object.keys(o).some((k) =>
      //     String(o[k]).toLowerCase().includes(value.toLowerCase())
      //   )
      // );

      // this.setState({
      //   data_asset: filteredWarehouse,
      // });

        }else{

    if (value === "") {
      console.log(
        "filter in actionnnnnn value = none",
        this.state.selectedRowKeys
      );
      const tempRowRecords = JSON.parse(
        JSON.stringify(this.state.selectedRowKeys)
      );
      this.setState(
        {
          rowRecords: [...this.state.rowRecords, ...tempRowRecords],
          selectedRowKeys: [
            ...new Set([...this.state.rowRecords, ...tempRowRecords]),
          ],
        },
        () => {
          const tempArray = JSON.parse(JSON.stringify(this.state.set_asset));
          this.state.selectedRowKeys.forEach((item) => {
            tempArray.sort((a, b) => {
              if (a.asset_id === item) return -1;
              else return 1;
            });
          });
          console.log("after add row keys", this.state.selectedRowKeys);

          

          this.setState({ data_asset: [...tempArray] , filter_act:1 });
        }
      );
    } else {
      this.setState({
        data_asset: [],
      });

      /*const filteredData = this.state.set_asset.filter((element) => 
    Object.keys(element).some((k) =>{
      //console.log('k',k)
          this.state.columns_asset.filter((col) =>             
          {
              k === col.dataIndex && String(element[col.dataIndex]).toLowerCase().includes(value.toLowerCase())
              //console.log('dataIndex',col.dataIndex)
              if(k === col.dataIndex){
                //console.log('element',element[col.dataIndex]);
                //String(element[col.dataIndex]).toLowerCase().includes(value.toLowerCase())
                console.log(element[col.dataIndex]);
                console.log(String(element[col.dataIndex]).toLowerCase().includes(value.toLowerCase()))
              }
            }
          )
      } 
      )
    );*/

      /*const filteredData = this.state.set_asset.filter((element) =>       
    this.state.columns_asset.map((col) => 
      String(element[col.dataIndex]).toLowerCase() === value.toLowerCase()
      // Object.keys(element).some((k) =>
      //   String(element[col.dataIndex]).toLowerCase().includes(value.toLowerCase())
      // )
        //String(element[col.dataIndex]).toLowerCase().includes(value.toLowerCase())
        // {
        //   console.log(col.dataIndex,element[col.dataIndex])
        // }
      )
    )*/

      // data_filter = this.state.data.filter(item => {
      //   const query = item;
      //   return (
      //     parseInt(query[type]) === parseInt(value) &&
      //     parseInt(query['priority_level']) === parseInt(this.state.filter.priority) &&
      //     Object.keys(item).some((k) =>
      //       String(item[k]).toLowerCase().includes(this.state.filter.search_text.toLowerCase())
      //     )
      //   )
      // });

      /*const filteredData = this.state.set_asset.filter((element) => {
        return (
          Object.keys(element).some((k) =>
          String(element['asset_id']).toLowerCase().includes(value.toLowerCase()) ||
          String(element['asset_code']).toLowerCase().includes(value.toLowerCase()) ||
          String(element['asset_name']).toLowerCase().includes(value.toLowerCase()) ||
          String(element['group_type_name']).toLowerCase().includes(value.toLowerCase()) ||
          String(element['asset_type_name']).toLowerCase().includes(value.toLowerCase())
          )
          )
        }        
        )
        
        console.log('filteredData',filteredData);*/

      // (element) =>
      // element.next_flow === "M" &&
      // element.next_main_process_name === "Complete"

      // this.state.columns_asset.filter((o) =>
      //   console.log(o.dataIndex)
      // );


      let filteredData = {};
      // console.log("set_asset", this.state.set_asset);
      const tempData = JSON.parse(JSON.stringify(this.state.set_asset));
      //console.log("filterrrr value", this.state.setDataAssign);
      filteredData = tempData.filter((o) =>
        Object.keys(o).some((k) => {
          return String(o[k]).toLowerCase().includes(value.toLowerCase());
        })
      );

      console.log("filteredData value", filteredData);
      console.log("filter data_asset value", this.state.data_asset);

      this.setState(
        {
          data_asset: filteredData,
          //set_asset : asset_code
          selectedRows: this.state.setDataAssign,
        },
        () => console.log("filter setDataAssign value", this.state.setDataAssign)
      );
    }
  }//end else
  }

  renderConf() {
    const {
      visible,
      value,
      mode,
      selectedRowKeys,
      columns_asset,
      columns_select,
      currentPage,
      selectedRows,
      data_asset,
      dataSourceSel,
      visibleConf,
      setDataAssign
    } = this.state;

    const components = {
      body: {
        row: EditableRow,
        cell: EditableCell,
      },
    };

    const columns_sel = this.columns.map((col) => {
      if (!col.editable) {
        return col;
      }

      return {
        ...col,
        onCell: (record) => ({
          record,
          editable: col.editable,
          dataIndex: col.dataIndex,
          title: col.title,
          handleSave: this.handleSave,
        }),
      };
    });

    const dateFormatList = ["DD/MM/YYYY", "DD/MM/YY"];

    return (
      <Modal
        title={
          <span className="font-mont-b font16 c-blue text-uppercase">
            confirm asset
          </span>
        }
        centered
        visible={visibleConf}
        footer={null}
        closable={false}
        className="custom-modal-map-large"
        // style={{ width: "570px" }}
      >

            <div className="col-12" style={{ marginBottom: "10px" , overflow : "auto" }}>
           
              <Table
                components={components}
                rowClassName={() => 'editable-row'}
                bordered
                dataSource={dataSourceSel}
                columns={columns_sel}
              />
            </div>

            {/* <div className="row" style={{ margin: "10px" }}>
              <div className="col-4">
              Job Category
              </div>

              <div className="col-4">
              Job Type
              </div>

              <div className="col-4">
              Job Sub Type
              </div>
            </div>

            <div className="row" style={{ margin: "10px" }}>
              <div className="col-4">
              <span className="font-thai-b c-blue font18">Check</span>
              </div>

              <div className="col-4">
              <span className="font-thai-b c-blue font18">Run zone</span>
              </div>

              <div className="col-4">
              <span className="font-thai-b c-blue font18">วิ่งตรงป้าย</span>
              </div>
            </div>

            <div className="row" style={{ marginTop: "20px" , marginLeft: "10px" , marginRight: "10px", marginBottom: "10px"  }}>
              <div className="col-4">
              Job Category
              </div>

              <div className="col-4">
              Job Type
              </div>

              <div className="col-4">
              Job Sub Type
              </div>
            </div>

            <div className="row" style={{ margin: "10px" }}>
              <div className="col-4">
              <span className="font-thai-b c-blue font18">Check</span>
              </div>

              <div className="col-4">
              <span className="font-thai-b c-blue font18">Run zone</span>
              </div>

              <div className="col-4">
              <span className="font-thai-b c-blue font18">วิ่งตรงป้าย</span>
              </div>
            </div>
            
            <div className="row" style={{ marginTop: "20px" , marginLeft: "10px" , marginRight: "10px", marginBottom: "10px"  }}>
              <div className="col-4">
              Job Category
              </div>

              <div className="col-4">
              Job Type
              </div>

              <div className="col-4">
              Job Sub Type
              </div>
            </div>

            <div className="row" style={{ margin: "10px" }}>
              <div className="col-4">
              <span className="font-thai-b c-blue font18">Check</span>
              </div>

              <div className="col-4">
              <span className="font-thai-b c-blue font18">Run zone</span>
              </div>

              <div className="col-4">
              <span className="font-thai-b c-blue font18">วิ่งตรงป้าย</span>
              </div>
            </div> */}

            <div className="col-12" style={{ textAlign: "center", marginBottom: "10px" , overflow : "auto" }}>
            <button
              type="reset"
              onClick={() => {
                //this.onModal("main", mode, false)   
                
                var txt;
                var r = window.confirm("การเปลี่ยนแปลงข้อมูลในหน้าปัจจุบันจะยังไม่ทำการบันทึก หากคุณต้องการกลับไปแก้ไขข้อมูล ดำเนินการต่อใช่หรือไม่");
                if (r == true) {
                  //console.log('back');
                  this.handleBack()
                  this.setState({
                  visible:true,
                  visibleConf:false
                })     

                } else {
                  console.log('cancel back');
                }
                    
              }
              }
              className="btn btn-secondary"
            >
              Back
            </button>
            <button className="btn btn-success"
             onClick={() => {
              //console.log('confirm')  
              this.handleAdd()

            }
            }
            >Confirm</button>
            </div>

        </Modal>
    )

  }

  renderModal() {
    const {
      visible,
      value,
      mode,
      selectedRowKeys,
      columns_asset,
      columns_select,
      currentPage,
      selectedRows,
      data_asset,
      dataSourceSel,
      filter_search
    } = this.state;

    const components = {
      body: {
        row: EditableRow,
        cell: EditableCell,
      },
    };

    const columns_sel = this.columns.map((col) => {
      if (!col.editable) {
        return col;
      }

      return {
        ...col,
        onCell: (record) => ({
          record,
          editable: col.editable,
          dataIndex: col.dataIndex,
          title: col.title,
          handleSave: this.handleSave,
        }),
      };
    });
    // console.log("selectedRowKeys", selectedRowKeys);
    // tempArray=[...data_asset]
    // selectedRows.forEach((item) => {
    //   console.log("itemm", item);
    //   tempArray.sort((a, b) => {
    //     if (a.asset_id === item || b.asset_id === item) return -1;
    //     else return 1;
    //   });
    // });
    const dateFormatList = ["DD/MM/YYYY", "DD/MM/YY"];

    const rowSelection = {
      selectedRowKeys,
      onChange: async (selectedRowKeys, selectedRows) => {
        // console.log("selectedRowKeys22222222", selectedRowKeys);
        console.log("onChange init selectedRowKeys ", selectedRowKeys);
        console.log("onChange init selectedRows ", selectedRows);

        if(false){

          const tempRowRecords = await JSON.parse(
            JSON.stringify(selectedRowKeys)
          );
          console.log('tempMulti : ',this.state.tempMulti);
          console.log('tempRowRecords',tempRowRecords);

          var difference = tempRowRecords.filter(x => this.state.tempMulti.indexOf(x) === -1);
          console.log('difference : ',difference);



          this.setState(
            {            
              // setDataAssign: selectedRows,
              // dataSourceSel: arrSelRow,
              selectedRowKeys: selectedRowKeys,
            }
          )

          
        }else{


        const tempRowRecords = await JSON.parse(
          JSON.stringify(selectedRowKeys)
        );

        console.log("before tempRowRecords ", tempRowRecords)
        console.log("selectedRowKeys ", selectedRowKeys);//real data filter multi select
        console.log("before arrConf ", this.state.arrConf)
        let arrTemp = this.state.arrConf
        // this.setState({
        //   arrConf:selectedRowKeys,
        // })
        // console.log("after arrConf ", this.state.arrConf)

        console.log("state selectedRowkeys", this.state.selectedRowKeys);
        let tempSelRowKey = this.state.selectedRowKeys;

        let mergeArray = [...selectedRowKeys, ...this.state.selectedRowKeys];
        console.log("state onChange state checkKeys", this.state.checkKeys);

        let check = this.state.tempCheckKeySel
        // console.log('mergeArrayyyy before', mergeArray )
        // console.log('mergeArrayyyy', mergeArray )
        //console.log("");
        console.log("selectedRows", selectedRows); ////****** this is key */
        console.log("count selectedRows", selectedRows.length); 

        console.log('onChange filter_search : ',this.state.filter_search);
        console.log("onChange dataSourceSel", this.state.dataSourceSel); //key decrease

        console.log("count dataSourceSel", this.state.dataSourceSel.length); 

        let i = 1;
        let arrSelRow = selectedRows          
        let arrSource = dataSourceSel
        let countSel = arrSelRow.length
        let addSel = 0 //0=remove,1=add
        console.log("onChange arrSelRow", arrSelRow);

        
        
        console.log('countSel : '+countSel);
        console.log('tempSelected : '+this.state.tempSelected);

        this.setState({
          arrReduceSel:arrSelRow
        })

        // let arrTemp = []
        // arrSource.map((item) => {
        //   console.log('arrSource asset_id : '+item.asset_id)
        //   arrTemp.push(item.asset_id)            
        //   });

        // append asset
        //if(selectedRows.length >= this.state.dataSourceSel.length){
        if(this.state.tempSelected === true){
          console.log('append asset');
          addSel = 1
          // arrSelRow.forEach(function (element) {     
          //   if(i !== countSel){
          //     element.order_no = arrSource[i-1].order_no;
          //   }else{
          //     element.order_no = 0;
          //   }
            
          //   i++;
          // });
        }else{
          // remove asset
          console.log('remove asset');
          addSel = 0
          console.log('check0',check[0]);

          console.log('remove arrSource',arrSource);
          arrSelRow = arrSource.filter(function( obj ) {
              return obj.asset_code !== check[0];
              //return obj.asset_id !== check[0];
          });

          console.log('remove arrSelRow',arrSelRow);

        }
                
        console.log('after arrSelRow',arrSelRow);

        if(this.state.tempSelected === true){
          console.log('append arrTemp')
          let count_temp = arrTemp.length
          console.log('after count_temp',count_temp);
          let index = 0
          arrSelRow.map((item) => {
            //console.log('arrSelRow asset_id : '+item.asset_id)
            if(index >= count_temp){
              arrTemp.push(item.asset_id)  
            } 
            index++
                      
            });
        }else{
          console.log('remove arrTemp')
          console.log('check0',check[0]);
          let arrRemove = arrTemp
          arrTemp = arrRemove.filter(function( obj ) {

            //return obj.asset_code !== check[0];
            return obj !== check[0];
        });

        // console.log('after arrRemove',arrRemove);
        // console.log('remove arrTemp',arrTemp);

        }
          console.log('after arrTemp',arrTemp);

          /******************************** multi deselect ********************************/
          if(arrSelRow.length === 0){
            console.log('arrSelRow empty arrTemp : ',arrTemp);
            console.log('empty rowRecords >> ', this.state.rowRecords); // << last asset
            console.log("empty dataSourceSel >> ", this.state.dataSourceSel);//** key decrease asset (filter)*/

            console.log('tempSelRowKey : ',tempSelRowKey);
            //rowRecords - tempSelRowKey

            let arrSelKey = []
            arrSelKey = this.state.rowRecords.filter( function( el ) {
              return !tempSelRowKey.includes( el );
            } );

            // this.state.rowRecords.filter(function( obj ) {
            //   tempSelRowKey.map((item, index) => ())

            //   return itm.id !== 2;
            // });

            /*this.state.rowRecords.forEach(function (element) {       
              console.log('rowRecords : ',element);
              tempSelRowKey.forEach(function (element) {

              });
              // arrSelKey = tempSelRowKey.filter(function( obj ) {
              //   return obj !== element;
              // });
            });*/

            console.log('arrSelKey : ',arrSelKey);

          //   let arrSelKey = this.state.rowRecords.filter(function( obj ) {
          //     return obj !== check[0];
          // });
            

            this.setState(
              {            
                setDataAssign: selectedRows,
                dataSourceSel: arrSelRow,
                selectedRowKeys: arrSelKey,
              }
            )
            

          }else{
            /******************************** select , deselect , multi select ********************************/
            console.log('arrSelRow value');          

              this.setState(
                {            
                  setDataAssign: selectedRows,
                  dataSourceSel: arrSelRow,
                  selectedRowKeys: selectedRowKeys,
                },
                () => {
                  this.setState(
                    {
                      rowRecords: [
                        ...new Set([...this.state.rowRecords, ...mergeArray]),
                      ],
                    },
                    () => {
                      //console.log("rowRecords_newsss ", this.state.rowRecords);
                      console.log("search filter : ",this.state.filter_search)
                      console.log("after rowRecordsssssssssss ", this.state.rowRecords);

                      this.setState(
                        {
                          // arrConf:this.state.rowRecords.filter(
                          //   (item) => !this.state.checkKeys.includes(item)
                          // ),
                          arrConf : arrTemp,
                          arrFilterRep : this.state.rowRecords,
                          rowRecords: this.state.rowRecords.filter(
                            (item) => !this.state.checkKeys.includes(item)
                          ),
                          // dataSourceSel:this.state.rowRecords.filter(
                          //   (item) => !this.state.checkKeys.includes(item)
                          // )
                        },
                        () => {
                          console.log("rowRecordsssssssssss ", this.state.rowRecords);
                          console.log("addSel ", addSel);
                          console.log("dataSourceSel ", this.state.dataSourceSel);//** key decrease asset (filter)*/
                          

                          // this.setState(
                          //   {
                          //     dataSourceSel:this.state.rowRecords
                          //   })

                        }
                      );

                      console.log('rowRecords:2 >> ', this.state.rowRecords);
                      console.log("addSel:2 ", addSel);
                      console.log("dataSourceSel:2 ", this.state.dataSourceSel);//** key decrease asset (filter)*/
                      
                      
                      

                    }
                  );
                }
              );
          }//end else

        }


      },
      // onSelect happen before onChange
      onSelect: async (record, selected, selectedRows, nativeEvent) => {
        // const { dataSourceSel } = this.state
        // let dataTemp = dataSourceSel
        // console.log('onSelect dataSourceSel',dataSourceSel);
        console.log("record and selected value(T/F)", record, selected);
        //dataTemp.push(record)
        // console.log('this.state.rowRecords onSelect', this.state.rowRecords)
        if (selected === false) {
          // this.state.rowRecords = this.state.rowRecords.filter(item => item !== record.asset_id)
          // this.setState({
          //   rowRecords: this.state.rowRecords
          // }   ,           () => {
          //   console.log("rowRecordsss 2 ", this.state.rowRecords);
          // })
          // console.log('record asset code', record.asset_code)
          let tempCheckKeys = [];
          tempCheckKeys.push(record.asset_code);
          console.log("tempCheckKeys", tempCheckKeys);
          this.setState(
            {
              checkKeys: [
                ...new Set([...this.state.checkKeys, ...tempCheckKeys]),
              ],
              tempCheckKeySel : tempCheckKeys,
              
            },
            () => {
              console.log("checkKeys", this.state.checkKeys);
            }
          );
        }

        this.setState({
          tempSelected : selected
        })
      },
      getCheckboxProps: (record) => ({
        disabled: record.name === "Disabled User",
        name: record.name,
      }),
    };

    // console.log("data_init", this.state.data_init);
    // console.log("startDate", this.state.startDate);

    console.log('render filter_search',filter_search);

    const columns_asset2 = [
      {
        title: <Checkbox 
        onChange={() => this.CheckboxAsset("all")} 
        checked={this.state.checkboxAll}
        //checked={() => {this.getCheckAll()}}
        ></Checkbox>,
        dataIndex: "",
        key: "",
        render: (item) => (
          <Checkbox
            onChange={() => this.CheckboxAsset(item)}
            checked={item["status_checkbox"]}
          ></Checkbox>
        ),

        // sorter: () => null,
      },
      {
        title: "Asset Code",
        dataIndex: "asset_code",
        key: "asset_code",
      },
      {
        title: "Asset Name",
        dataIndex: "asset_name",
        key: "asset_name",
        render: (item) => (
        <span>{item}</span>
        ),
      },
      {
        title: "Group Type",
        dataIndex: "group_type_name",
        key: "group_type_name",
      },
      {
        title: "Asset Type",
        dataIndex: "asset_type_name",
        key: "asset_type_name",
      },
    ]

    return (
      <Modal
        title={
          <span className="font-mont-b font16 c-blue text-uppercase">
            {mode} Maintenance
          </span>
        }
        centered
        visible={visible}
        footer={null}
        closable={false}
        className="custom-modal-map-large"
        // style={{ width: "570px" }}
      >


      <div className="row" style={{ margin: "10px" }}>
        <div className="col-4">
        <Search
                placeholder=" Search Asset "
                style={{ width: 350 }}
                onChange={(e) => {
                  this.onFilter(e.target.value)
                  //console.log('filter')
                  this.setState({
                    filter_search : e.target.value
                  })
                }}
                defaultValue={filter_search}

              />
        </div>
        <div className="col-12" style={{ marginBottom: "10px" , overflow : "auto" }}>
        <Table
                size="middle"
                rowKey="asset_id"
                // rowSelection={rowSelection}
                columns={columns_asset2}
                // rowKey={record =>record.asset_id} //This one must be selected
                pagination={{
                  onChange: (page) => this.setState({ currentPage: page }),
                  current: currentPage,
                }}
                dataSource={this.state.data_asset ? this.state.data_asset  : []}
              />           
        </div>       
      </div>



        {/** Form */}
        <Form
          onFinish={this.handleConf}
          ref={this.formRef}
          layout="vertical"
          initialValues={{...this.state.data_init,
            start_date: moment(this.state.startDate, dateFormatList[0]),
            end_date: moment(this.state.startDate, dateFormatList[0]),
          }}
        > 
           <div
            className="row"
            style={{ marginLeft: "10px", marginRight: "10px" }}
          >
              {/* <div className="col-4">
              <Form.Item
                name="planning_group"
                label="Group Name"
                rules={[
                  { required: true, message: "Planning Group" },
                ]}
              >
                <Select
                  style={{ width: "100%" }}
                  placeholder="Please select"
                  onChange={(value) => this.onChangeasset("group_name", value)}

                >
                  {this.state.planning_group.map((item, index) => (
                    <Select.Option
                      value={item.group_id}
                      key={index}
                      obj={item}
                    >
                      {item.group_name}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
              </div> */}
          </div>

          <div className="row" style={{ margin: "10px" }}>            
            
            {/* <div className="col-4">
            <Form.Item
                key="search_asset"
                name="search_asset"               
              >
              <Search
                placeholder=" Search Asset "
                style={{ width: 350 }}
                onChange={(e) => {
                  this.onFilter(e.target.value)
                  //console.log('filter')
                  this.setState({
                    filter_search : e.target.value
                  })
                }}
              />
              </Form.Item>
            </div>
           
            <div className="col-12" style={{ marginBottom: "10px" , overflow : "auto" }}>
              <Table
                size="middle"
                rowKey="asset_id"
                // rowSelection={rowSelection}
                columns={columns_asset}
                // rowKey={record =>record.asset_id} //This one must be selected
                pagination={{
                  onChange: (page) => this.setState({ currentPage: page }),
                  current: currentPage,
                }}
                dataSource={this.state.data_asset}
              />
            </div> */}

            
            <div className="col-6">
              {/* <Form.Item
                name="select_team_emp"
                label="Select Team / Employee"
                rules={[
                  {
                    required: false,
                    message: "Select Team / Employee is required",
                  },
                ]}
              >
                <Select
                  style={{ width: "100%" }}
                  placeholder="Please select"
                  onChange={(value) => this.onChangeasset("team_emp", value)}
                >
                  {this.state.select_team_emp.map((item, index) => (
                    <Select.Option value={item.valus} key={index} obj={item}>
                      {item.text}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item> */}
            </div>
            {this.state.fact_team ? (
              <div className="col-6">
                <Form.Item
                  name="select_team"
                  label="Select Team"
                  rules={[
                    { required: true, message: "Select Team is required" },
                  ]}
                >
                  <Select
                    style={{ width: "100%" }}
                    placeholder="Please select"
                    onChange={(value) => this.onChangeasset("team", value)}
                  >
                    {this.state.select_team.map((item, index) => (
                      <Select.Option
                        value={item.team_id}
                        key={index}
                        obj={item}
                      >
                        {item.team_sub_name}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              </div>
            ) : null}
            {/* {this.state.fact_emp ? (
              <div className="col-6">
                <Form.Item
                  name="select_employee"
                  label="Select Employee"
                  rules={[
                    { required: true, message: "Select Employee is required" },
                  ]}
                >
                  <Select
                    style={{ width: "100%" }}
                    placeholder="Please select"
                    onChange={(value) => this.onChangeasset("employee", value)}
                  >
                    {this.state.select_employee.map((item, index) => (
                      <Select.Option
                        value={item.employee_id}
                        key={index}
                        obj={item}
                      >
                        {item.emp_name}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              </div>
            ) : null} */}
          </div>

          <div
            className="row"
            style={{ marginLeft: "10px", marginRight: "10px" }}
          >
            <div className="col-4">
              <Form.Item
                key="plan_name"
                name="plan_name"
                label="Planning Name"
                rules={[
                  {
                    required: true,
                    message: `Planning name is required`,
                  },
                ]}
              >
                <Input
                  type="text"
                  className="font-mont-r font12"
                  size="middle"
                />
              </Form.Item>
            </div>

            <div className="col-4">
              <Form.Item
                name="start_date"
                label="Start Date"
                // rules={[{ required: true, message: "Start Date is required" }]}
              >
                <DatePicker
                  style={{ width: "100%" }}
                  // defaultValue={moment(this.state.startDate, dateFormatList[0])}
                  // onChange={
                  //   (date) =>
                  //     (this.state.form["start_date"] = moment(date).format(
                  //       "YYYY-MM-DD"
                  //     ))
                  //   // // moment(value).format("YYYY-MM-DD")
                  //   // console.log(date)
                  // }
                />
              </Form.Item>
            </div>

            <div className="col-4">
             <Form.Item
                name="end_date"
                label="End Date"
                // rules={[{ required: true, message: "Start Date is required" }]}
              >
                <DatePicker
                  style={{ width: "100%" }}
                  // defaultValue={moment(this.state.startDate, dateFormatList[0])}
                  // onChange={
                  //   (date) =>
                  //     (this.state.form["end_date"] = moment(date).format(
                  //       "YYYY-MM-DD"
                  //     ))
                  //   // // moment(value).format("YYYY-MM-DD")
                  //   // console.log(date)
                  // }
                />
              </Form.Item>
            </div>
          </div>

          <div
            className="row"
            style={{ marginLeft: "10px", marginRight: "10px" }}
          >

          <div className="col-4">
              <Form.Item
                name="job_category"
                label="Job Category"
                rules={[
                  { required: true, message: "Job Category is required" },
                ]}
              >
                <Select
                  style={{ width: "100%" }}
                  placeholder="Please select"
                  onChange={(value) =>
                    this.onChangeasset("job_category_id", value)
                  }
                >
                  {this.state.job_category.map((item, index) => (
                    <Select.Option
                      value={item.job_category_id}
                      key={index}
                      obj={item}
                    >
                      {item.job_category_name}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </div>

            <div className="col-4">
              <Form.Item
                name="job_type_id"
                label="Job Type"
                rules={[{ required: true, message: "Job Type is required" }]}
              >
                <Select
                  style={{ width: "100%" }}
                  placeholder="Please select"
                  onChange={(value) => this.onChangeasset("job_type", value)}
                >
                  {this.state.job_type.map((item, index) => (
                    <Select.Option
                      value={item.job_type_id}
                      key={index}
                      obj={item}
                    >
                      {item.job_type_name}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </div>

            <div className="col-4">
              <Form.Item
                name="job_sub_type_id"
                label="Job Sub Type"
                rules={[
                  { required: true, message: "Job Sub Type is required" },
                ]}
              >
                <Select
                  style={{ width: "100%" }}
                  placeholder="Please select"
                  onChange={(value) =>
                    this.onChangeasset("job_sub_type", value)
                  }
                >
                  {this.state.job_sub_type.map((item, index) => (
                    <Select.Option
                      value={item.job_sub_type_id}
                      key={index}
                      obj={item}
                    >
                      {item.job_type_name}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </div>
            <div className="col-4">
              <Form.Item
                name="group_id"
                label="Group name"
                rules={[
                  { required: true, message: "Group name  is required" },
                ]}
              >
                <Select
                  style={{ width: "100%" }}
                  placeholder="Please select"
                  onChange={(value, item) =>
                    this.onChangeasset("group_name", value, item)
                  }
                >
                  {this.state.group_list.map((item, index) => (
                    <Select.Option
                      value={item.group_id}
                      key={index}
                      obj={item}
                    >
                      {item.group_name}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </div>
            </div>

          
          <Form.Item
            name="maintenance_name"
            label=""
            style={{ marginLeft: "28px" }}
          >
            <Checkbox 
            checked={this.state.checked_auto}
            onChange={this.onChangeCheck}>
              <span className="font-thai-b c-blue font18">Auto Gen Job</span>
            </Checkbox>
          </Form.Item>

          { this.state.checked_auto && 
          <div
            className="row"
            style={{ marginLeft: "10px", marginRight: "10px" }}
          >
            <div className="col-4">
              <Form.Item                
                name="repeat_time"
                label="Repeat Time"
                rules={[{ required: true, message: "Repeat Time is required" }]}
              >
                <Select
                  disabled={this.state.disabled_repeat_time}
                  style={{ width: "100%" }}
                  placeholder="Please select"
                  // defaultValue="2"
                  onChange={(value) => this.onChangeasset("repeat_time", value)}
                >
                  {this.state.select_repeat_time.map((item, index) => (
                    <Select.Option value={item.value} key={index} obj={item}>
                      {item.text}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </div>
            <div className="col-4">
              <Form.Item
                name="repeat_every"
                label="Repeat every"
                // rules={[
                //   { required: true, message: "Repeat every is required" },
                // ]}
              >
                <InputNumber
                  disabled={this.state.disabled_repeat}
                  min={1}
                  max={30}
                  width="100%"
                  defaultValue={1}
                  onChange={(value) => console.log(value)}
                  style={{ width: "100%" }}
                />
              </Form.Item>
            </div>
            <div className="col-4">
              <Form.Item
                name="repeat_day"
                label="Day"
                rules={[
                  { required: true, message: "Select Repeat day is required" },
                ]}
                style={{ width: "100%" }}
              >
                <Select
                  // defaultValue="2"
                  disabled={this.state.disabled_repeat}
                  placeholder="Please select"
                  onChange={(value) => this.onChangeasset("repeat_day", value)}
                >
                  {this.state.select_repeat_day.map((item, index) => (
                    <Select.Option value={item.value} key={index} obj={item}>
                      {item.text}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </div>
          </div>          
          }
          
          <Form.Item className="mb-0 text-center">
            <button
              type="reset"
              onClick={() => {
                console.log('this.state.set_asset',this.state.set_asset)
                console.log('checkboxAll',this.state.checkboxAll);
                //this.CheckboxAsset('all',true)
                this.CheckboxAsset('all')
                for (let i = 0; i < this.state.set_asset.length; i++) {
                  this.state.set_asset[i]["status_checkbox"] = false
                }

                this.setState({
                  visible : false,
                  tempMulti:[],
                  data_asset:this.state.set_asset,
                  checkboxAll:!this.state.checkboxAll
                })           
              }
              }
              className="btn btn-secondary"
            >
              Cancel
            </button>
            <button className="btn btn-success">Submit</button>
          </Form.Item>
        </Form>
      </Modal>
    );
  }

  setFieldsValue(v) {
    this.formRef.current.setFieldsValue(v);
  }
  getForm() {
    return this.formRef.current;
  }

  async onSelectTab(active) {
    const { startOfMonth , endOfMonth } = this.state
    

    const job_calendar1 = await Api.post("v2/jobEmployeeCalender", {
      company_id: Cookies.get("companyid"),
      operator_id: Cookies.get("operator_id"),
      project_id: Cookies.get("project_id"),
      auto_gen_job: (active === 0 ? 1:0),
      work_pm_start: startOfMonth,
      work_pm_end: endOfMonth,
      group_id: null ,
      group_name: null
    });

    this.setState({ 
      tab_auto:active,
      list:job_calendar1.data.data
     });
  }

  render() {
    const { list } = this.state;
    // console.log(localizer,'localizer');
    return (
      <LoadingOverlay
        active={this.state.loading}
        spinner
        text='Loading ...'
        >
      <Fragment>
        <div style={{ padding: "20px", borderBottom: "1px solid #E3E3E3" }}>
          <div className="d-flex justify-content-between">
            <ul className="navTwo" style={{ visibility: "hidden" }}>
              <li>
                <div>
                  <span className="font-thai-sb font18 mr-2">Month</span>
                  <DatePicker onChange={this.onSelectMonth} picker="month" />
                </div>
              </li>
              <li>
                <span className="font-thai-sb font18 mr-2">Team Group</span>
                <Select
                  placeholder="Please select"
                  optionFilterProp="children"
                  className="font-mont-r font12"
                >
                  <Option value="">All</Option>
                  <Option value="jack">Team 01</Option>
                  <Option value="lucy">Team 02</Option>
                  <Option value="tom">Team 03</Option>
                </Select>
              </li>
              <li>
                <span className="font-thai-sb font18 mr-2">Team Sub</span>
                <Select
                  placeholder="Please select"
                  optionFilterProp="children"
                  className="font-mont-r font12"
                >
                  <Option value="">All</Option>
                  <Option value="jack">Team Sub 01</Option>
                  <Option value="lucy">Team Sub 02</Option>
                  <Option value="tom">Team Sub 03</Option>
                </Select>
              </li>
              <li>
                <span className="font-thai-sb font18 mr-2">Area Code</span>
                <Select
                  placeholder="Please select"
                  optionFilterProp="children"
                  className="font-mont-r font12"
                >
                  <Option value="">All</Option>
                  <Option value="jack">BKK1</Option>
                  <Option value="lucy">BKK2</Option>
                  <Option value="tom">BKK3</Option>
                </Select>
              </li>
            </ul>
            <button
              type="button"
              className="btn btn-warning"
              onClick={() => this.onModal("main", "add", true)}
              // onClick={() => this.setState({visible : true})}
            >
              {/* <img src="./icon/plus.svg" className="mr-2" /> */}
              <img
                src={ChangePath.absoluteUrl("/icon/plus.svg")}
                className="mr-2"
              />
                Add Maintenance
            </button>
          </div>
        </div>
        <div className="row">
          <div className="col-8 pr-0">
            <div style={{ padding: "20px" }}>
              <Calendar
                localizer={localizer}
                events={this.state.events}
                startAccessor="start"
                endAccessor="end"
                //views={["month", "week", "day"]}
                views={["month", "day"]}
                style={{ height: 700 }}
                onSelectEvent={(event) => {
                  this.selectCalendar(event);
                }}
                onNavigate={(date) => {
                  this.changeCalendar(date);
                }}
              />
            </div>
          </div>
          <div className="col-4 pl-0">
            <div className="wrapper-calendar-today">
              <div className="d-flex justify-content-between mb-2">
                <div>
                  <span
                    style={{ lineHeight: "20px" }}
                    className="d-block font-thai-r font24 c-blue"
                  >
                    {/* Friday */}
                    {/* {moment().format('dddd')} */}
                  </span>
                  {/* <h3 className="font-thai-b font26 c-blue m-0">6 November 2020</h3> */}
                  <h3 className="font-thai-b font26 c-blue m-0">
                    {/* {moment(this.state.startOfMonth).format("MMMM YYYY")} */}
                    <ul className="nav">
                      <li className="nav-item font12 font-mont-sb mr-1">
                        <a
                          className={this.state.tab_auto == 0 ? "nav-link active" : "nav-link"}
                          // className={"nav-link active"}
                          onClick={() => this.onSelectTab(0)}
                        >
                          <Translate text="tab_auto" />
                        </a>
                      </li>
                      <li className="nav-item font12 font-mont-sb mr-1">
                        <a
                          className={this.state.tab_auto == 1 ? "nav-link active" : "nav-link"}
                          // className={"nav-link"}
                          onClick={() => this.onSelectTab(1)}
                        >
                          <Translate text="tab_manual" />
                        </a>
                      </li>
                    </ul>
                  </h3>

                </div>
                <div className="text-right">
                  <h3
                    style={{ lineHeight: "25px" }}
                    className="font-thai-b font40 c-blue m-0"
                  >
                    {list.length}
                  </h3>
                  <span className="text-uppercase font-thai-b font20 c-black">
                    Jobs
                  </span>
                </div>
              </div>
              {/* {console.log(list, "list CardCalendar")} */}
              {list.map((item, index) => (
                <CardCalendar
                  key={index}
                  data={item}
                  editPlan={this.editPlan.bind(this)}
                />
              ))}
            </div>
          </div>
        </div>
        {this.renderModal()}
        {this.renderSuccess()}
        {this.renderConf()}
      </Fragment>
      </LoadingOverlay>
    );
  }
}

export default CalendarPlan;
